import LitJsSdk from "lit-js-sdk";
import axios from "axios";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { fromString as uint8arrayFromString } from "uint8arrays/from-string";
import {
  contractAddress,
  bondingCurveContractAddress,
  bondingCurveOrchestratorContractAddress,
  nounsAuctionHouseContractAddress,
  authorizationContractAddress,
  leaderboardContractAddress,
  hypeRaceLeaderboardContractAddress,
  gasGiftingContractAddress,
  subscriptionContractAddress,
  mainnetContractAddress,
  mainnetBondingCurveContractAddress,
  mainnetBondingCurveOrchestratorContractAddress,
  mainnetNounsAuctionHouseContractAddress,
  mainnetAuthorizationContractAddress,
  mainnetGasGiftingContractAddress,
} from "./config";
import { DateTime } from "luxon";
import { v4 as uuidv4 } from "uuid";
const siwe = require("siwe");

const {
  REACT_APP_PUBLIC_KEY,
  REACT_APP_PRIVATE_KEY,
  REACT_APP_GOERLI_API_URL,
  REACT_APP_ETHEREUM_API_URL,
  REACT_APP_API_URL,
  REACT_APP_PROD_API_URL,
  REACT_APP_IS_MAINNET,
} = process.env;

let web3;
let web3Eth;
let web3EthMainnet;
let writeProvider;
if(window.ethereum == null || window.ethereum.providers == null) {
  writeProvider = window.ethereum;
} else {
  writeProvider = window.ethereum.providers.find((provider) => provider.isMetaMask);
}

console.log(REACT_APP_IS_MAINNET);
if (REACT_APP_IS_MAINNET !== "testnet") {
  if(writeProvider == null) {
    web3 = createAlchemyWeb3(REACT_APP_PROD_API_URL);
    web3Eth = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL);
    web3EthMainnet = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL);
  } else {
    web3 = createAlchemyWeb3(REACT_APP_PROD_API_URL, {writeProvider: writeProvider});
    web3Eth = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL, {writeProvider: writeProvider});
    web3EthMainnet = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL, {writeProvider: writeProvider});
  }
} else {
  if(writeProvider == null) {
    web3 = createAlchemyWeb3(REACT_APP_API_URL);
    web3Eth = createAlchemyWeb3(REACT_APP_GOERLI_API_URL);
    web3EthMainnet = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL);
  } else {
    web3 = createAlchemyWeb3(REACT_APP_API_URL, {writeProvider: writeProvider});
    web3Eth = createAlchemyWeb3(REACT_APP_GOERLI_API_URL, {writeProvider: writeProvider});
    web3EthMainnet = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL, {writeProvider: writeProvider});
  }
}
const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
let ppvContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  ppvContract = new web3Eth.eth.Contract(contract.abi, mainnetContractAddress);
} else {
  ppvContract = new web3Eth.eth.Contract(contract.abi, contractAddress);
}
const contract2 = require("./artifacts/contracts/Leaderboard.sol/Leaderboard.json");
const leaderboardContract = new web3.eth.Contract(
  contract2.abi,
  leaderboardContractAddress
);
const hypeRaceLeaderboardContract = new web3.eth.Contract(
  contract2.abi,
  hypeRaceLeaderboardContractAddress
);
const contract3 = require("./artifacts/contracts/Authorization.sol/Authorization.json");
let authorizationContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  authorizationContract = new web3.eth.Contract(
    contract3.abi,
    mainnetAuthorizationContractAddress
  );
} else {
  authorizationContract = new web3.eth.Contract(
    contract3.abi,
    authorizationContractAddress
  );
}
const contract4 = require("./artifacts/contracts/GasGifting.sol/GasGifting.json");
let gasGiftingContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  gasGiftingContract = new web3.eth.Contract(
    contract4.abi,
    mainnetGasGiftingContractAddress
  );
} else {
  gasGiftingContract = new web3.eth.Contract(
    contract4.abi,
    gasGiftingContractAddress
  );
}
const contract5 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
let bondingCurveContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  bondingCurveContract = new web3Eth.eth.Contract(
    contract5.abi,
    mainnetBondingCurveContractAddress
  );
} else {
  bondingCurveContract = new web3Eth.eth.Contract(
    contract5.abi,
    bondingCurveContractAddress
  );
}
const contract6 = require("./artifacts/contracts/NounsToken.sol/NounsToken.json");
const contract7 = require("./artifacts/contracts/NounsAuctionHouse.sol/NounsAuctionHouse.json");
let nounsAuctionHouseContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  nounsAuctionHouseContract = new web3Eth.eth.Contract(
    contract7.abi,
    mainnetNounsAuctionHouseContractAddress
  );
} else {
  nounsAuctionHouseContract = new web3Eth.eth.Contract(
    contract7.abi,
    nounsAuctionHouseContractAddress
  );
}

const contract8 = require("./artifacts/contracts/Subscription.sol/Subscription.json");
const subscriptionContract = new web3.eth.Contract(
  contract8.abi,
  subscriptionContractAddress
);

const contract9 = require("./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json");
const contract10 = require("./artifacts/contracts/BondingCurveNFTV2.sol/BondingCurveNFTV2.json");
let bondingCurveOrchestratorContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  bondingCurveOrchestratorContract = new web3Eth.eth.Contract(
    contract9.abi,
    mainnetBondingCurveOrchestratorContractAddress
  );
} else {
  bondingCurveOrchestratorContract = new web3Eth.eth.Contract(
    contract9.abi,
    bondingCurveOrchestratorContractAddress
  );
}

let zoraAbi = require("./artifacts/contracts/Zora721.sol/Zora721.json");
const { ethers } = require("ethers");

let graphURL;
let bondingCurveGraphURL;
let bondingCurveV2GraphURL;
let authorizationGraphURL;
let nounsGraphURL;
if (REACT_APP_IS_MAINNET !== "testnet") {
  graphURL = "https://api.thegraph.com/subgraphs/name/narahari28/ppv";
  bondingCurveGraphURL =
    "https://api.goldsky.com/api/public/project_cl86hlobe1mwy0huzh2xqhveh/subgraphs/bondingcurve/0.0.1/gn";
  bondingCurveV2GraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/bondingcurvev2";
  authorizationGraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/authorization";
  nounsGraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/nounsauction";
} else {
  graphURL = "https://api.thegraph.com/subgraphs/name/narahari28/ppvtest";
  bondingCurveGraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/bondingcurvetest";
  bondingCurveV2GraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/bondingcurvev2test";
  authorizationGraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/authorizationtest";
  nounsGraphURL =
    "https://api.thegraph.com/subgraphs/name/narahari28/nounsauctiontest";
}

export async function getProvider() {
  if (typeof window.ethereum !== "undefined") {
    if(window.ethereum.providers == null) {
      return window.ethereum;
    }
    const provider = window.ethereum.providers.find((provider) => provider.isMetaMask);
    await provider.request({ method: 'eth_requestAccounts' });
    return provider;
  }
  return null;
}

export async function getCurrentEthGasPriceOverrideToMainnet() {
  let data = await axios.get(
    "https://api.etherscan.io/api?module=proxy&action=eth_gasPrice&apikey=IJHX7PT3EA3FU7WHRCYA5KYZDWSSVNJAAI"
  );
  if (data != null) {
    console.log(data);
    return parseInt(data["data"]["result"], 16);
  } else {
    return null;
  }
}

export async function getCurrentEthGasPrice() {
  let data;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    data = await axios.get(
      "https://api.etherscan.io/api?module=proxy&action=eth_gasPrice&apikey=IJHX7PT3EA3FU7WHRCYA5KYZDWSSVNJAAI"
    );
  } else {
    data = await axios.get(
      "https://api-goerli.etherscan.io/api?module=proxy&action=eth_gasPrice&apikey=IJHX7PT3EA3FU7WHRCYA5KYZDWSSVNJAAI"
    );
  }
  if (data != null) {
    console.log(data);
    return parseInt(data["data"]["result"], 16);
  } else {
    return null;
  }
}

export async function getCurrentGasPrice() {
  let data;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    data = await axios.get("https://gasstation-mainnet.matic.network/v2");
  } else {
    data = await axios.get("https://gasstation-mumbai.matic.today/v2");
  }
  if (data != null) {
    console.log(data);
    return parseInt(data["data"]["fast"]["maxPriorityFee"] * 1000000000);
  } else {
    return null;
  }
}

async function estimateGas(transactionObj) {
  let gas;
  try {
    gas = parseInt((await web3.eth.estimateGas(transactionObj)) * 1.03);
  } catch (err) {
    console.log(err);
    gas = 10000000;
  }
  console.log(gas);
  return gas;
}

export async function getENS(address) {
  try {
    var name = await ethers.getDefaultProvider().lookupAddress(address);
    if (name == null) {
      return (
        address.substring(0, 5) + "..." + address.substring(address.length - 5)
      );
    }
    return name;
  } catch(err) {
    return address;
  }
}

export function getWalletUnconnectedUserId() {
  var id = localStorage.getItem("wallet_unconnected_user_id");
  if(id != null) {
    return id;
  } else {
    localStorage.setItem("wallet_unconnected_user_id", "wallet_unconnected_user_" + getAuthUUID());
  }
}

export function getCrossmintUserId() {
  var id = localStorage.getItem("crossmint_user_id");
  if(id != null) {
    return id.toLowerCase();
  }
  return null;
}

export function getAuthUUID() {
  return uuidv4();
}

export async function doesOwnOldNFT(oldContracts, tokenIds, areShared721, address) {
  let abiFor721 = require("./artifacts/contracts/Zora721.sol/Zora721.json");
  let jsonFor1155 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
  let abiFor1155 = jsonFor1155.abi;
  for(let i = 0; i < oldContracts.length; i++) {
    if(tokenIds[i] !== -1) {
      if(areShared721[i]) {
        let contract = new web3EthMainnet.eth.Contract(zoraAbi, oldContracts[i]);
        let owner = await contract.methods.ownerOf(tokenIds[i]).call();
        if(owner.toLowerCase() === address.toLowerCase()) {
          return true;
        }
      } else {
        let contract = new web3EthMainnet.eth.Contract(abiFor1155, oldContracts[i]);
        let balance = await contract.methods.balanceOf(address, tokenIds[i]).call();
        if(balance > 0) {
          return true;
        }
      }
    } else {
      let contract = new web3EthMainnet.eth.Contract(abiFor721, oldContracts[i]);
      let balance = await contract.methods.balanceOf(address).call();
      if(balance > 0) {
        return true;
      }
    }
  }
  return false;
}

export async function getSubscriberStatuses() {
  let query = `
    {
      creators {
        id,
        subscribers {
          subscriber
        }
      }
    }
  `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/subscriptiontest",
    { query }
  );
  let ans = {}
  if(data != null && data["data"] != null && data["data"]["data"] != null && data["data"]["data"]["creators"] != null) {
    let creators = data["data"]["data"]["creators"];
    for(let i = 0; i < creators.length; i++) {
      let creatorMapping = {}
      let creatorInfo = data["data"]["data"]["creators"][i];
      let subscribers = creatorInfo["subscribers"];
      for(let j = 0; j < subscribers.length; j++) {
        creatorMapping[subscribers[j]["subscriber"]] = true;
      }
      ans[creatorInfo["id"]] = creatorMapping;
    }
  }
  console.log(ans);
  return ans;
}

export async function getNFTsFromAPI(address) {
  let data = await axios.post(
    "https://rl43y8zojj.execute-api.us-west-2.amazonaws.com/dev/get_items_from_db",
    {
      creatorAddress: address,
    }
  );
  return data;
}

export async function getNFTsFromOpensea(address, catalogName, otherAddress, glassCollections, twitter) {
  let data = await axios.post(
    "https://rl43y8zojj.execute-api.us-west-2.amazonaws.com/dev/get_items_from_apis",
    {
      creatorAddress: address,
      catalogName,
      otherAddress,
      glassCollections,
      twitter
    }
  );
  return data;
}

export async function getLeaderboardData(tokenCID, listener) {
  if (listener != null) {
    listener = listener.toLowerCase();
  }
  let query = `
        {
            mediaItem(id:${'"' + tokenCID + '"'}){
                upvotes,
                userData(where:{user:${'"' + listener + '"'}}){
                  userMediaVote,
                }
            }
        }
    `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/leaderboardtest",
    { query }
  );
  let totalUpvotes = 0;
  let userVote = false;
  if (data["data"]["data"]["mediaItem"] != null) {
    totalUpvotes = data["data"]["data"]["mediaItem"]["upvotes"];
    if (data["data"]["data"]["mediaItem"]["userData"].length > 0) {
      userVote =
        data["data"]["data"]["mediaItem"]["userData"][0]["userMediaVote"];
    }
  }
  return {
    totalUpvotes: totalUpvotes,
    userVote: userVote,
  };
}

export async function getHyperaceLeaderboardData(tokenCID, listener) {
  if (listener != null) {
    listener = listener.toLowerCase();
  }
  let query = `
        {
            mediaItem(id:${'"' + tokenCID + '"'}){
                upvotes,
                userData(where:{user:${'"' + listener + '"'}}){
                  userMediaVote,
                }
            }
        }
    `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/hyperaceleaderboardtest",
    { query }
  );
  let totalUpvotes = 0;
  let userVote = false;
  if (data["data"]["data"]["mediaItem"] != null) {
    totalUpvotes = data["data"]["data"]["mediaItem"]["upvotes"];
    if (data["data"]["data"]["mediaItem"]["userData"].length > 0) {
      userVote =
        data["data"]["data"]["mediaItem"]["userData"][0]["userMediaVote"];
    }
  }
  return {
    totalUpvotes: totalUpvotes,
    userVote: userVote,
  };
}

export async function getLeaderboardDataBulk(items, listener, uriAttribute) {
  if (listener == null) {
    return items;
  }
  listener = listener.toLowerCase();
  let tokenCIDs = [];
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item[uriAttribute] == null) {
      continue;
    }
    let uriSplit = item[uriAttribute].split("/");
    let tokenCID = uriSplit[uriSplit.length - 1];
    tokenCIDs.push('"' + tokenCID + '"');
  }
  let query = `
    {
      mediaItems(where: {id_in:${"[" + tokenCIDs + "]"}}){
        id,
        upvotes,
        userData(where:{user:${'"' + listener + '"'}}){
          userMediaVote,
        }
      }
    }
  `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/leaderboardtest",
    { query }
  );
  let allUpvoteInfo = {};
  for (let i = 0; i < data["data"]["data"]["mediaItems"].length; i++) {
    let datum = data["data"]["data"]["mediaItems"][i];
    let id = datum["id"];
    let totalUpvotes = datum["upvotes"];
    let userVote = false;
    if (datum["userData"].length > 0) {
      userVote = datum["userData"][0]["userMediaVote"];
    }
    allUpvoteInfo[id] = {
      totalUpvotes: totalUpvotes,
      userVote: userVote,
    };
  }
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item[uriAttribute] == null) {
      item["totalUpvotes"] = 0;
      item["userVote"] = false;
      items[i] = item;
      continue;
    }
    let uriSplit = item[uriAttribute].split("/");
    let tokenCID = uriSplit[uriSplit.length - 1];
    if (tokenCID in allUpvoteInfo) {
      item["totalUpvotes"] = allUpvoteInfo[tokenCID]["totalUpvotes"];
      item["userVote"] = allUpvoteInfo[tokenCID]["userVote"];
    } else {
      item["totalUpvotes"] = 0;
      item["userVote"] = false;
    }
    items[i] = item;
  }
  return items;
}

export async function getHyperaceLeaderboardDataBulk(
  items,
  listener,
  uriAttribute
) {
  if (listener == null) {
    return items;
  }
  listener = listener.toLowerCase();
  let tokenCIDs = [];
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item[uriAttribute] == null) {
      continue;
    }
    let uriSplit = item[uriAttribute].split("/");
    let tokenCID = uriSplit[uriSplit.length - 1];
    tokenCIDs.push('"' + tokenCID + '"');
  }
  let query = `
    {
      mediaItems(where: {id_in:${"[" + tokenCIDs + "]"}}){
        id,
        upvotes,
        userData(where:{user:${'"' + listener + '"'}}){
          userMediaVote,
        }
      }
    }
  `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/hyperaceleaderboardtest",
    { query }
  );
  let allUpvoteInfo = {};
  for (let i = 0; i < data["data"]["data"]["mediaItems"].length; i++) {
    let datum = data["data"]["data"]["mediaItems"][i];
    let id = datum["id"];
    let totalUpvotes = datum["upvotes"];
    let userVote = false;
    if (datum["userData"].length > 0) {
      userVote = datum["userData"][0]["userMediaVote"];
    }
    allUpvoteInfo[id] = {
      totalUpvotes: totalUpvotes,
      userVote: userVote,
    };
  }
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item[uriAttribute] == null) {
      item["totalUpvotes"] = 0;
      item["userVote"] = false;
      items[i] = item;
      continue;
    }
    let uriSplit = item[uriAttribute].split("/");
    let tokenCID = uriSplit[uriSplit.length - 1];
    if (tokenCID in allUpvoteInfo) {
      item["totalUpvotes"] = allUpvoteInfo[tokenCID]["totalUpvotes"];
      item["userVote"] = allUpvoteInfo[tokenCID]["userVote"];
    } else {
      item["totalUpvotes"] = 0;
      item["userVote"] = false;
    }
    items[i] = item;
  }
  return items;
}

export async function getTop100Rank(top100) {
  console.log("top100 of current week:");
  console.log(top100);
  var nowLuxon = DateTime.now().setZone("America/New_York");
  var now = new Date();
  now.setYear(nowLuxon.year);
  now.setMonth(nowLuxon.month - 1);
  now.setDate(nowLuxon.day);
  now.setHours(nowLuxon.hour);
  now.setMinutes(nowLuxon.minute);
  var start = new Date(now.getFullYear(), 0, 1);
  var startLuxon = DateTime.fromJSDate(start).setZone("America/New_York");
  start = new Date();
  start.setYear(startLuxon.year);
  start.setMonth(startLuxon.month - 1);
  start.setDate(startLuxon.day);
  start.setHours(startLuxon.hour);
  start.setMinutes(startLuxon.minute);
  var dayMilliseconds = 1000 * 60 * 60 * 24;
  var sundays = 1;
  while (start <= now) {
    var day = start.getDay();
    if (day === 0) {
      sundays++;
    }
    start = new Date(+start + dayMilliseconds);
  }
  console.log("starting sun: " + sundays);
  let top100Track = top100;
  let currSun = sundays;
  let currWeek = (sunday) => "2022/" + sunday;
  let getQuery = (week) => `
        {
            weekMediaItems(first:100 where:{week:${
              '"' + week + '"'
            }} orderBy: totalWeeklyStreams, orderDirection: desc){
                mediaItem{
                  id
                },
                totalWeeklyStreams
            }
        }
    `;

  while (currSun >= 22) {
    currSun--;
    let thisWeek = currWeek(currSun);
    let query = getQuery(thisWeek);
    let data = await axios.post(
      "https://api.thegraph.com/subgraphs/name/narahari28/leaderboardtest",
      { query }
    );
    let currMediaItems = data["data"]["data"]["weekMediaItems"];
    console.log("Week: " + thisWeek);
    console.log(currMediaItems);
    top100Track.map((item) => {
      let itemId = item["tokenCID"];
      let indexOfCurr = currMediaItems.findIndex(
        (currItem) => currItem["mediaItem"]["id"] === itemId
      );
      let sunDiff = sundays - currSun;
      if (item["1rank"] === undefined) {
        item["1rank"] = "--";
      }
      if (item["2rank"] === undefined) {
        item["2rank"] = "--";
      }
      if (item["3rank"] === undefined) {
        item["3rank"] = "--";
      }
      if (sunDiff < 4) {
        item[sunDiff + "rank"] =
          indexOfCurr !== -1 ? (indexOfCurr + 1).toString() : "--";
      }
      if (item["weeksOnLeaderboard"] === undefined) {
        item["weeksOnLeaderboard"] = 1;
      }
      if (indexOfCurr !== -1) {
        item["weeksOnLeaderboard"]++;
      }
    });
  }

  return top100Track;
}

export async function getTop100() {
  var nowLuxon = DateTime.now().setZone("America/New_York");
  var now = new Date();
  now.setYear(nowLuxon.year);
  now.setMonth(nowLuxon.month - 1);
  now.setDate(nowLuxon.day);
  now.setHours(nowLuxon.hour);
  now.setMinutes(nowLuxon.minute);
  var start = new Date(now.getFullYear(), 0, 1);
  var startLuxon = DateTime.fromJSDate(start).setZone("America/New_York");
  start = new Date();
  start.setYear(startLuxon.year);
  start.setMonth(startLuxon.month - 1);
  start.setDate(startLuxon.day);
  start.setHours(startLuxon.hour);
  start.setMinutes(startLuxon.minute);
  var dayMilliseconds = 1000 * 60 * 60 * 24;
  var sundays = 1;
  while (start <= now) {
    var day = start.getDay();
    if (day === 0) {
      sundays++;
    }
    start = new Date(+start + dayMilliseconds);
  }
  start = new Date(+start + dayMilliseconds);
  let curWeek = now.getFullYear() + "/" + sundays;
  console.log(curWeek);
  let query = `
        {
            weekMediaItems(first:100 where:{week:${
              '"' + curWeek + '"'
            }} orderBy: totalWeeklyStreams, orderDirection: desc){
                mediaItem{
                  id
                },
                totalWeeklyStreams
            }
        }
    `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/leaderboardtest",
    { query }
  );
  console.log(data);
  return data["data"]["data"]["weekMediaItems"];
}

export async function getTop100Monthly() {
  let now = new Date();
  let curMonth = now.getFullYear() + "/" + (now.getMonth() + 1);
  let query = `
        {
            monthMediaItems(first:130 where:{month:${
              '"' + curMonth + '"'
            }} orderBy: totalMonthlyStreams, orderDirection: desc){
                mediaItem{
                  id
                },
                totalMonthlyStreams
            }
        }
    `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/leaderboardtest",
    { query }
  );
  return data["data"]["data"]["monthMediaItems"];
}

export async function getAuthSig() {
  let chain;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    chain = "polygon";
  } else {
    chain = "mumbai";
  }
  return await LitJsSdk.checkAndSignAuthMessage({ chain: chain });
}

export async function getAuthSigForceTestnet() {
  let chain = "mumbai";
  return await LitJsSdk.checkAndSignAuthMessage({ chain: chain });
}

export async function getAuthSigDedicatedWallet(privateKey) {
  const AUTH_SIGNATURE_BODY =
    "I am creating an account to use Lit Protocol at {{timestamp}}";
  const privKeyBuffer = uint8arrayFromString(privateKey, "base16");
  const wallet = new ethers.Wallet(privKeyBuffer);

  const domain = "localhost";
  const origin = "https://localhost/login";
  const statement =
    "This is a test statement.  You can put anything you want here.";

  const siweMessage = new siwe.SiweMessage({
    domain,
    address: wallet.address,
    statement,
    uri: origin,
    version: "1",
    chainId: REACT_APP_IS_MAINNET ? "137" : "80001",
  });

  const messageToSign = siweMessage.prepareMessage();

  const signature = await wallet.signMessage(messageToSign);

  const recoveredAddress = ethers.utils.verifyMessage(messageToSign, signature);

  return {
    sig: signature,
    derivedVia: "web3.eth.personal.sign",
    signedMessage: messageToSign,
    address: recoveredAddress,
  };
}

export async function getAuthSigDedicatedWalletForceTestnet(privateKey) {
  const AUTH_SIGNATURE_BODY =
    "I am creating an account to use Lit Protocol at {{timestamp}}";
  const privKeyBuffer = uint8arrayFromString(privateKey, "base16");
  const wallet = new ethers.Wallet(privKeyBuffer);

  const domain = "localhost";
  const origin = "https://localhost/login";
  const statement =
    "This is a test statement.  You can put anything you want here.";

  const siweMessage = new siwe.SiweMessage({
    domain,
    address: wallet.address,
    statement,
    uri: origin,
    version: "1",
    chainId: "80001",
  });

  const messageToSign = siweMessage.prepareMessage();

  const signature = await wallet.signMessage(messageToSign);

  const recoveredAddress = ethers.utils.verifyMessage(messageToSign, signature);

  return {
    sig: signature,
    derivedVia: "web3.eth.personal.sign",
    signedMessage: messageToSign,
    address: recoveredAddress,
  };
}

export async function encryptString(email, publicKey, authSig) {
  const { encryptedString, symmetricKey } = await LitJsSdk.encryptString(email);
  let chain = "mumbai";
  const accessControlConditions = [
    {
      contractAddress: '',
      standardContractType: '',
      chain,
      method: '',
      parameters: [
        ':userAddress',
      ],
      returnValueTest: {
        comparator: '=',
        value: publicKey
      }
    }
  ];

  const client = new LitJsSdk.LitNodeClient();
  await client.connect();
  window.litNodeClient = client;
  
  const encryptedSymmetricKey = await window.litNodeClient.saveEncryptionKey({
    authSig,
    chain,
    accessControlConditions,
    symmetricKey,
  });

  const encryptedStringObject = {
    encryptedSymmetricKey,
    encryptedString,
  };
  return encryptedStringObject;
}

export async function decryptString(
  encryptedSymmetricKey,
  encryptedString,
  publicKey,
  authSig
) {
  const client = new LitJsSdk.LitNodeClient();
  await client.connect();
  window.litNodeClient = client;
  let chain = "mumbai";
  const accessControlConditions = [
    {
      contractAddress: '',
      standardContractType: '',
      chain,
      method: '',
      parameters: [
        ':userAddress',
      ],
      returnValueTest: {
        comparator: '=',
        value: publicKey
      }
    }
  ];
  const symmetricKey = await window.litNodeClient.getEncryptionKey({
    accessControlConditions,
    toDecrypt: LitJsSdk.uint8arrayToString(encryptedSymmetricKey, "base16"),
    chain,
    authSig,
  });

  const decryptedString = await LitJsSdk.decryptString(
    encryptedString,
    symmetricKey
  );

  return decryptedString;
}

export async function encryptSong(songData, authUUID, authSig) {
  const readableStreamForFile = songData[0];
  console.log("File before encrypting");
  console.log(readableStreamForFile);

  const { encryptedFile, symmetricKey } = await LitJsSdk.encryptFile({
    file: readableStreamForFile,
  });

  const client = new LitJsSdk.LitNodeClient();
  await client.connect();
  window.litNodeClient = client;

  let accessCondition;
  for (let i = 0; i < contract3["abi"].length; i++) {
    if (contract3["abi"][i]["name"] === "isAuthorizedToView") {
      accessCondition = contract3["abi"][i];
    }
  }
  let chain;
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    chain = "polygon";
    usedContractAddress = mainnetAuthorizationContractAddress;
  } else {
    chain = "mumbai";
    usedContractAddress = authorizationContractAddress;
  }
  const evmContractConditions = [
    {
      contractAddress: usedContractAddress,
      functionName: "isAuthorizedToView",
      functionParams: [":userAddress", authUUID],
      functionAbi: accessCondition,
      chain,
      returnValueTest: {
        key: "",
        comparator: "=",
        value: "true",
      },
    },
  ];
  const encryptedSymmetricKey = await window.litNodeClient.saveEncryptionKey({
    authSig,
    chain,
    evmContractConditions,
    symmetricKey,
  });

  const encryptedSongReturnObject = {
    encryptedSymmetricKey,
    encryptedBlob: encryptedFile,
  };
  return encryptedSongReturnObject;
}

export async function writeBlobPinata(encryptedBlob, fileName) {
  let hashURL = "";
  let pinHash = "";
  let pinFileUrl = `https://api.pinata.cloud/pinning/pinFileToIPFS`;
  const name = `encrypted-${fileName}-data`;

  let data = new FormData();
  data.append("file", encryptedBlob);
  const metadata = JSON.stringify({ name: name + "-blob" });
  data.append("pinataMetadata", metadata);

  await axios
    .post(pinFileUrl, data, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("there was an error writing the song to Pinata ", error);
    });

  hashURL = `https://the402.mypinata.cloud/ipfs/${pinHash}`;
  return hashURL;
}

export async function writeBlobMetadataPinata(
  blobURL,
  encryptedSymmetricKey,
  title
) {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  let pinHash = "";
  let JSONBody = {
    pinataMetadata: {
      name: title,
    },
    pinataContent: {
      encryptedURL: blobURL,
      encryptedSymmetricKey
    },
  };

  await axios
    .post(url, JSONBody, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("there was an error writing the NFT to Pinata ", error);
    });

  return pinHash;
}

export async function writeSongPinata(encryptedSongInfo, fileName) {
  const { encryptedBlob } = encryptedSongInfo;

  let fileNameUnderscore = fileName.replaceAll(" ", "_");

  let hashURL = "";
  let pinHash = "";
  let pinFileUrl = `https://api.pinata.cloud/pinning/pinFileToIPFS`;
  const name = `encrypted-${fileNameUnderscore}-data`;

  let data = new FormData();
  data.append("file", encryptedBlob);
  const metadata = JSON.stringify({ name: name + "-blob" });
  data.append("pinataMetadata", metadata);

  await axios
    .post(pinFileUrl, data, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("there was an error writing the song to Pinata ", error);
    });

  hashURL = `https://the402.mypinata.cloud/ipfs/${pinHash}`;
  return hashURL;
}

export async function writeMetadataPinata(
  blobURL,
  encryptedSymmetricKey,
  itemParams
) {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  const title = itemParams.name;
  const description = itemParams.description;
  const image = itemParams.image;
  const imagePinata = itemParams.imagePinata;
  const creatorRoyaltyPercentage = itemParams.creatorRoyaltyPercentage;
  const impressionFee = itemParams.impressionFee * 1000000000000000000;
  const impressionPercentage = itemParams.impressionPercentage;
  const creatorShares = itemParams.creatorShares;
  const creatorName = itemParams.creatorName;
  const creatorAddress = itemParams.creatorAddress;
  const holderShares = itemParams.holderShares;
  const editions = itemParams.editions;
  const animation_url =
    itemParams.animation_url != null ? itemParams.animation_url : "";
  //mint price stored in Pinata as Wei
  const mintPrice = itemParams.mintPrice * 1000000000000000000;
  console.log(mintPrice);

  let pinHash = "";
  let JSONBody = {
    pinataMetadata: {
      name: title,
    },
    pinataContent: {
      name: title,
      creatorName,
      animation_url,
      description,
      image,
      imagePinata,
      encryptedURL: blobURL,
      encryptedSymmetricKey,
      impressionFee,
      impressionPercentage,
      creatorShares,
      holderShares,
      creatorRoyaltyPercentage,
      creatorAddress,
      editions,
      mintPrice,
    },
  };

  await axios
    .post(url, JSONBody, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("there was an error writing the NFT to Pinata ", error);
    });

  return pinHash;
}

export async function writeMetadataPinataBondingCurve(itemParams) {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  const title = itemParams.name;
  const description = itemParams.description;
  const image = itemParams.image;
  const imagePinata = itemParams.imagePinata;
  const creatorRoyaltyPercentage = itemParams.creatorRoyaltyPercentage;
  const creatorName = itemParams.creatorName;
  const creatorAddress = itemParams.creatorAddress;
  const animation_url =
    itemParams.animation_url != null ? itemParams.animation_url : "";

  let pinHash = "";
  let JSONBody = {
    pinataMetadata: {
      name: title,
    },
    pinataContent: {
      name: title,
      creatorName,
      animation_url,
      description,
      image,
      imagePinata,
      creatorRoyaltyPercentage,
      creatorAddress,
    },
  };

  await axios
    .post(url, JSONBody, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("there was an error writing the NFT to Pinata ", error);
    });

  return pinHash;
}

export async function writeMetadataPinataNouns(itemParams, index) {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  const title = itemParams.name + " " + index;
  const description = itemParams.description;
  const image = itemParams.image;
  const imagePinata = itemParams.imagePinata;
  const animation_url = itemParams.animation_url;
  const creatorName = itemParams.creatorName;
  const creatorAddress = itemParams.creatorAddress;
  const mediaType = itemParams.mediaType;

  let pinHash = "";
  let JSONBody = {
    pinataMetadata: {
      name: title,
    },
    pinataContent: {
      name: title,
      creatorName,
      description,
      image,
      imagePinata,
      creatorAddress,
      animation_url,
      mediaType
    },
  };

  await axios
    .post(url, JSONBody, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      pinHash = response.data.IpfsHash;
    })
    .catch(function (error) {
      console.log("Error for:");
      console.log(itemParams);
      console.log("there was an error writing the NFT to Pinata ", error);
    });

  return pinHash;
}

export async function writeFilePinata(fileName, file) {
  let data = new FormData();
  const url = "https://api.pinata.cloud/pinning/pinFileToIPFS";
  let returnUrl = "";

  console.log(fileName);
  console.log(file);

  let fileNameUnderscore = fileName.replaceAll(" ", "_");
  const title = `${fileNameUnderscore}-image`;

  data.append("file", file[0]);

  const metadata = JSON.stringify({
    name: title,
  });

  data.append("pinataMetadata", metadata);

  await axios
    .post(url, data, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })

    .then(function (response) {
      const pinHash = response.data.IpfsHash;
      returnUrl = `https://the402.mypinata.cloud/ipfs/${pinHash}`;
    })
    .catch(function (error) {
      console.log("there was an error posting to Pinata: ", error);
    });

  return returnUrl;
}

export async function writeSingleFilePinata(fileName, file) {
  let data = new FormData();
  const url = "https://api.pinata.cloud/pinning/pinFileToIPFS";
  let returnUrl = "";

  console.log(fileName);
  console.log(file);

  let fileNameUnderscore = fileName.replaceAll(" ", "_");
  const title = `${fileNameUnderscore}-image`;

  data.append("file", file);

  const metadata = JSON.stringify({
    name: title,
  });

  data.append("pinataMetadata", metadata);

  await axios
    .post(url, data, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })

    .then(function (response) {
      const pinHash = response.data.IpfsHash;
      returnUrl = `https://the402.mypinata.cloud/ipfs/${pinHash}`;
    })
    .catch(function (error) {
      console.log("Error for:");
      console.log(file)
      console.log("there was an error posting to Pinata: ", error);
    });

  return returnUrl;
}

export async function getNFTUrlPinata(fileName) {
  const queryString = `?metadata[name]=${fileName}`;
  const url = `https://api.pinata.cloud/data/pinList${queryString}`;
  let returnUrl = "";

  await axios
    .get(url, {
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
    })
    .then(function (response) {
      const pinHash = response.data.rows[0].ipfs_pin_hash;
      returnUrl = `https://the402.mypinata.cloud/ipfs/${pinHash}`;
    })
    .catch(function (error) {
      console.log("there was an error getting NFT URL from Pinata: ", error);
    });

  return returnUrl;
}

export async function decryptSong(
  encryptedSymmetricKey,
  encryptedBlob,
  authUUID,
  authSig
) {
  const client = new LitJsSdk.LitNodeClient();
  await client.connect();
  window.litNodeClient = client;

  let accessCondition;
  for (let i = 0; i < contract3["abi"].length; i++) {
    if (contract3["abi"][i]["name"] === "isAuthorizedToView") {
      accessCondition = contract3["abi"][i];
    }
  }
  let chain;
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    chain = "polygon";
    usedContractAddress = mainnetAuthorizationContractAddress;
  } else {
    chain = "mumbai";
    usedContractAddress = authorizationContractAddress;
  }
  const evmContractConditions = [
    {
      contractAddress: usedContractAddress,
      functionName: "isAuthorizedToView",
      functionParams: [":userAddress", authUUID],
      functionAbi: accessCondition,
      chain,
      returnValueTest: {
        key: "",
        comparator: "=",
        value: "true",
      },
    },
  ];
  const symmetricKey = await window.litNodeClient.getEncryptionKey({
    evmContractConditions,
    toDecrypt: LitJsSdk.uint8arrayToString(encryptedSymmetricKey, "base16"),
    chain,
    authSig,
  });

  let decryptedSong = "";

  try {
    decryptedSong = await LitJsSdk.decryptFile({
      file: encryptedBlob,
      symmetricKey,
    });
  } catch (error) {
    console.log(
      "Error: Incorrect symmetric key, encrypted content, or do not meet conditions.\n",
      error
    );
  }

  return decryptedSong;
}

export async function hasGiftedGas(address) {
  return await gasGiftingContract.methods.hasUserBeenGiftedGas(address).call();
}

export async function giftGas(recipient) {
  let hasGiftedGasToUser = await hasGiftedGas(recipient);
  if (hasGiftedGasToUser) {
    return;
  }
  const nonce = await web3.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetGasGiftingContractAddress;
  } else {
    usedContractAddress = gasGiftingContractAddress;
  }

  let transactionData = gasGiftingContract.methods
    .giftGas(recipient)
    .encodeABI();

  const gas = 10000000;
  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce: nonce,
    gas: gas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: REACT_APP_IS_MAINNET !== "testnet" ? 137 : 80001
  };

  const signPromise = web3.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logUpvote(tokenCID, viewerAddress) {
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = leaderboardContract.methods
    .registerUpvote(tokenCID, viewerAddress)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: leaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logUpvoteHyperace(tokenCID, viewerAddress) {
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = hypeRaceLeaderboardContract.methods
    .registerUpvote(tokenCID, viewerAddress)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: hypeRaceLeaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logRemoveUpvote(tokenCID, viewerAddress) {
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = leaderboardContract.methods
    .registerRemoveUpvote(tokenCID, viewerAddress)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: leaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logRemoveUpvoteHyperace(tokenCID, viewerAddress) {
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = hypeRaceLeaderboardContract.methods
    .registerRemoveUpvote(tokenCID, viewerAddress)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: hypeRaceLeaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logImpression(tokenCID, viewerAddress) {
  var nowLuxon = DateTime.now().setZone("America/New_York");
  var now = new Date();
  now.setYear(nowLuxon.year);
  now.setMonth(nowLuxon.month - 1);
  now.setDate(nowLuxon.day);
  now.setHours(nowLuxon.hour);
  now.setMinutes(nowLuxon.minute);
  var start = new Date(now.getFullYear(), 0, 1);
  var startLuxon = DateTime.fromJSDate(start).setZone("America/New_York");
  start = new Date();
  start.setYear(startLuxon.year);
  start.setMonth(startLuxon.month - 1);
  start.setDate(startLuxon.day);
  start.setHours(startLuxon.hour);
  start.setMinutes(startLuxon.minute);
  var dayMilliseconds = 1000 * 60 * 60 * 24;
  var sundays = 1;
  while (start <= now) {
    var day = start.getDay();
    if (day === 0) {
      sundays++;
    }
    start = new Date(+start + dayMilliseconds);
  }
  let curWeek = now.getFullYear() + "/" + sundays;
  let curMonth = now.getFullYear() + "/" + (now.getMonth() + 1);
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = leaderboardContract.methods
    .registerStream(tokenCID, viewerAddress, curMonth, curWeek)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: leaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function logImpressionHyperace(tokenCID, viewerAddress) {
  var nowLuxon = DateTime.now().setZone("America/New_York");
  var now = new Date();
  now.setYear(nowLuxon.year);
  now.setMonth(nowLuxon.month - 1);
  now.setDate(nowLuxon.day);
  now.setHours(nowLuxon.hour);
  now.setMinutes(nowLuxon.minute);
  var start = new Date(now.getFullYear(), 0, 1);
  var startLuxon = DateTime.fromJSDate(start).setZone("America/New_York");
  start = new Date();
  start.setYear(startLuxon.year);
  start.setMonth(startLuxon.month - 1);
  start.setDate(startLuxon.day);
  start.setHours(startLuxon.hour);
  start.setMinutes(startLuxon.minute);
  var dayMilliseconds = 1000 * 60 * 60 * 24;
  var sundays = 1;
  while (start <= now) {
    var day = start.getDay();
    if (day === 0) {
      sundays++;
    }
    start = new Date(+start + dayMilliseconds);
  }
  let curWeek = now.getFullYear() + "/" + sundays;
  let curMonth = now.getFullYear() + "/" + (now.getMonth() + 1);
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = hypeRaceLeaderboardContract.methods
    .registerStream(tokenCID, viewerAddress, curMonth, curWeek)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: hypeRaceLeaderboardContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function getSubscribers(address, authSig) {
  let queryAddress = address.toLowerCase();
  let query = `
    {
      creator(id:${'"' + queryAddress + '"'}) {
        subscribers {
          subscriber
          ipfsCID
        }
      }
    }
  `;
  let data = await axios.post(
    "https://api.thegraph.com/subgraphs/name/narahari28/subscriptiontest",
    { query }
  );
  if(data != null && data["data"] != null && data["data"]["data"] != null && data["data"]["data"]["creator"] != null) {
    let rawData = data["data"]["data"]["creator"]["subscribers"];
    let promises = rawData.map(async (subscriber) => {
      try {
        let subscriberAddress = subscriber["subscriber"];
        let metadataHash = subscriber["ipfsCID"];
        let result = await axios.get("https://the402.mypinata.cloud/ipfs/" + metadataHash);
        let symmetricKeyRaw = result["data"]["encryptedSymmetricKey"];
        let encryptedStringURL = result["data"]["encryptedURL"];
        let encryptedSymmetricKeyRetrieved = Object.keys(symmetricKeyRaw).map(function (
          key
        ) {
          return symmetricKeyRaw[key];
        });
        encryptedSymmetricKeyRetrieved = Uint8Array.from(encryptedSymmetricKeyRetrieved);
        let encryptedStringRetrieved = await fetch(encryptedStringURL).then((res) =>
          res.blob()
        );
        let decryptedString = await decryptString(
          encryptedSymmetricKeyRetrieved,
          encryptedStringRetrieved,
          queryAddress,
          authSig
        );
        return {
          "address": subscriberAddress,
          "email": decryptedString
        }
      } catch (error) {
        return null;
      }
    });
    let ans = await Promise.allSettled(promises);
    ans = ans.map(x => x.value).filter(x => x);
    return ans;
  }
  return [];
}

export async function logSubscription(creatorAddress, subscriberAddress, ipfsURL) {
  let web3Test = createAlchemyWeb3(REACT_APP_API_URL);
  const nonce = await web3Test.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let transactionData = subscriptionContract.methods
    .registerSubscription(creatorAddress, subscriberAddress, ipfsURL)
    .encodeABI();

  const estimatedGas = 10000000;

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: subscriptionContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: 80001
  };

  const signPromise = web3Test.eth.accounts.signTransaction(
    tx,
    process.env.REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3Test.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (err) {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function getEthBalance(publicKey) {
  return web3Eth.eth.getBalance(publicKey);
}

export async function approveAccessMM(publicKey, authUUID, value) {
  const maxGasPrice = await getCurrentGasPrice();
  let provider = await getProvider();

  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetAuthorizationContractAddress;
    await provider.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x89",
          rpcUrls: ["https://matic-mainnet.chainstacklabs.com"],
          chainName: "MATIC",
          nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
          },
          blockExplorerUrls: ["https://polygonscan.com/"],
        },
      ],
    });
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x89" }], // MATIC
    });
  } else {
    usedContractAddress = authorizationContractAddress;
    await provider.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x13881",
          rpcUrls: ["https://matic-mumbai.chainstacklabs.com"],
          chainName: "Mumbai",
          nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
          },
          blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
        },
      ], // Mumbai MATIC
    });
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x13881" }], // Mumbai MATIC
    });
  }

  let authorizationContractAsUser = new web3.eth.Contract(
    contract3.abi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  try {
    const transactionData = authorizationContractAsUser.methods
      .authorizeAccessToView(authUUID, publicKey)
      .encodeABI();
    const estimatedGas = await estimateGas({
      from: publicKey,
      value: value,
      data: transactionData,
    });
    let sendTxPromise = new Promise(function (resolve, reject) {
      web3.eth
        .sendTransaction({
          from: publicKey,
          gas: estimatedGas,
          maxPriorityFeePerGas: maxGasPrice,
          value: value,
          data: transactionData,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 137 : 80001
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function isAuthorized(publicKey, authUUID) {
  return await authorizationContract.methods
    .isAuthorizedToView(publicKey, authUUID)
    .call();
}

export async function revokeAccess(address, authUUID) {
  const nonce = await web3.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetAuthorizationContractAddress;
  } else {
    usedContractAddress = authorizationContractAddress;
  }

  let transactionData = authorizationContract.methods
    .revokeAccessToView(address, authUUID)
    .encodeABI();

  const estimatedGas = await estimateGas({
    from: REACT_APP_PUBLIC_KEY,
    nonce: nonce,
    to: usedContractAddress,
    data: transactionData,
  });

  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: REACT_APP_IS_MAINNET !== "testnet" ? 137 : 80001
  };

  const signPromise = web3.eth.accounts.signTransaction(
    tx,
    REACT_APP_PRIVATE_KEY
  );
  signPromise
    .then((signedTx) => {
      web3.eth.sendSignedTransaction(
        signedTx.rawTransaction,
        function (err, hash) {
          if (!err) {
            console.log(
              "The hash of your transaction is: ",
              hash,
              "\nCheck Alchemy's Mempool to view the status of your transaction!"
            );
          } else {
            console.log(
              "Something went wrong when submitting your transaction:",
              err
            );
          }
        }
      );
    })
    .catch((err) => {
      console.log(" Promise failed:", err);
    });
}

export async function mintToken(publicKey, tokenId, mintPrice) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = contractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let ppvContractAsUser = new web3Eth.eth.Contract(
    contract.abi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  try {
    const estimatedGas = await ppvContractAsUser.methods
      .mintTokens(1, tokenId)
      .estimateGas({ value: mintPrice + 1 });

    let sendTxPromise = new Promise(function (resolve, reject) {
      ppvContractAsUser.methods
        .mintTokens(1, tokenId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: mintPrice + 1,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function buyBondingCurveItem(publicKey, item, protocol) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  let bondingCurveContractAsUser;
  if(protocol === "liquid") {
    if (REACT_APP_IS_MAINNET !== "testnet") {
      usedContractAddress = mainnetBondingCurveContractAddress;
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }], // ETH
      });
    } else {
      usedContractAddress = bondingCurveContractAddress;
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x5" }], // Gorli
      });
    }

    bondingCurveContractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    usedContractAddress = item["tokenContractAddress"];
    if (REACT_APP_IS_MAINNET !== "testnet") {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }], // ETH
      });
    } else {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x5" }], // Gorli
      });
    }

    bondingCurveContractAsUser = new web3Eth.eth.Contract(
      contract10.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await bondingCurveContractAsUser.methods
      .mintToken(protocol === "liquid" ? item.tokenId : item.collectionId, publicKey)
      .estimateGas({ value: item.mintPrice + 1 });
    let sendTxPromise = new Promise(function (resolve, reject) {
      bondingCurveContractAsUser.methods
        .mintToken(protocol === "liquid" ? item.tokenId : item.collectionId, publicKey)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: item.mintPrice + 1,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function sellBondingCurveItem(publicKey, item, protocol) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  let bondingCurveContractAsUser;
  if(protocol === "liquid") {
    if (REACT_APP_IS_MAINNET !== "testnet") {
      usedContractAddress = mainnetBondingCurveContractAddress;
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }], // ETH
      });
    } else {
      usedContractAddress = bondingCurveContractAddress;
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x5" }], // Gorli
      });
    }

    bondingCurveContractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    usedContractAddress = item["tokenContractAddress"];
    if (REACT_APP_IS_MAINNET !== "testnet") {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }], // ETH
      });
    } else {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x5" }], // Gorli
      });
    }

    bondingCurveContractAsUser = new web3Eth.eth.Contract(
      contract10.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await bondingCurveContractAsUser.methods
      .burnToken(protocol === "liquid" ? item.tokenId : item.collectionId)
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      bondingCurveContractAsUser.methods
        .burnToken(protocol === "liquid" ? item.tokenId : item.collectionId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function buyZora721Emote(publicKey, contractAddress, price) {
  const maxGasPrice = await getCurrentEthGasPriceOverrideToMainnet();
  let provider = await getProvider();

  let usedContractAddress = contractAddress;
  await provider.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: "0x1" }], // ETH
  });
  let contractAsUser = new web3EthMainnet.eth.Contract(
    zoraAbi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  try {
    const estimatedGas = await contractAsUser.methods
      .purchase(1)
      .estimateGas({value: price});

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .purchase(1)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: price,
          chainId: 1
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function buyManifold721Emote(publicKey, contractAddress, claimId, price) {
  let abiFor721 = require("./artifacts/contracts/Manifold721.sol/LazyMinting.json");
  const maxGasPrice = await getCurrentEthGasPriceOverrideToMainnet();
  let provider = await getProvider();

  let usedContractAddress = "0x5ebFD58C5eAd1025755F7490e510cCf2C0b4a444";
  await provider.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: "0x1" }], // ETH
  });
  let contractAsUser = new web3EthMainnet.eth.Contract(
    abiFor721,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  try {
    const estimatedGas = await contractAsUser.methods
      .mint(contractAddress, claimId, 0, [])
      .estimateGas({value: price});

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .mint(contractAddress, claimId, 0, [])
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: price,
          chainId: 1
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function buyManifold1155Emote(publicKey, contractAddress, price, tokenId) {
  let abiFor1155 = require("./artifacts/contracts/Manifold1155.sol/LazyMinting.json");
  const maxGasPrice = await getCurrentEthGasPriceOverrideToMainnet();
  let provider = await getProvider();

  let usedContractAddress = "0x4e32004D8b81847A670b4a1778ACe4dCF2bBA01E";
  await provider.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: "0x1" }], // ETH
  });
  let contractAsUser = new web3EthMainnet.eth.Contract(
    abiFor1155,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  try {
    const estimatedGas = await contractAsUser.methods
      .mint(contractAddress, tokenId, 0, [])
      .estimateGas({value: price});

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .mint(contractAddress, tokenId, 0, [])
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: price,
          chainId: 1
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function claimPOAP(publicKey) {
  let data = await axios.post(
    "https://hnfkh0g6r4.execute-api.us-west-2.amazonaws.com/dev/claim_poap",
    {
      claimerAddress: publicKey
    }
  );
  if(data["data"] == null) {
    return [];
  } else {
    return data["data"];
  }
}

export async function payStreamer(publicKey, streamerAddress, amount) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  try {
    let sendTxPromise = new Promise(function (resolve, reject) {
      web3Eth.eth.sendTransaction({to:streamerAddress, from:publicKey, value:web3Eth.utils.toWei(amount)})
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function listNFT(publicKey, tokenId, protocol, price, amount) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();

  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    if (protocol === "the402") {
      usedContractAddress = mainnetContractAddress;
    } else {
      usedContractAddress = mainnetBondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    if (protocol === "the402") {
      usedContractAddress = contractAddress;
    } else {
      usedContractAddress = bondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let contractAsUser;
  if (protocol === "the402") {
    contractAsUser = new web3Eth.eth.Contract(
      contract.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    contractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await contractAsUser.methods
      .createMarketItem(tokenId, price.toString(), amount)
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .createMarketItem(tokenId, price.toString(), amount)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function delistNFT(publicKey, marketItemId, protocol) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    if (protocol === "the402") {
      usedContractAddress = mainnetContractAddress;
    } else {
      usedContractAddress = mainnetBondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    if (protocol === "the402") {
      usedContractAddress = contractAddress;
    } else {
      usedContractAddress = bondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let contractAsUser;
  if (protocol === "the402") {
    contractAsUser = new web3Eth.eth.Contract(
      contract.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    contractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await contractAsUser.methods
      .delistMarketItem(marketItemId)
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .delistMarketItem(marketItemId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function editPriceNFT(
  publicKey,
  marketItemId,
  protocol,
  newPrice
) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    if (protocol === "the402") {
      usedContractAddress = mainnetContractAddress;
    } else {
      usedContractAddress = mainnetBondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    if (protocol === "the402") {
      usedContractAddress = contractAddress;
    } else {
      usedContractAddress = bondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let contractAsUser;
  if (protocol === "the402") {
    contractAsUser = new web3Eth.eth.Contract(
      contract.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    contractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await contractAsUser.methods
      .updatePriceMarketItem(marketItemId, newPrice.toString())
      .estimateGas();
    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .updatePriceMarketItem(marketItemId, newPrice.toString())
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function purchaseNFT(publicKey, marketItemId, protocol, price) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();

  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    if (protocol === "the402") {
      usedContractAddress = mainnetContractAddress;
    } else {
      usedContractAddress = mainnetBondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    if (protocol === "the402") {
      usedContractAddress = contractAddress;
    } else {
      usedContractAddress = bondingCurveContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let contractAsUser;
  if (protocol === "the402") {
    contractAsUser = new web3Eth.eth.Contract(
      contract.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  } else {
    contractAsUser = new web3Eth.eth.Contract(
      contract5.abi,
      usedContractAddress,
      {
        from: publicKey,
      }
    );
  }

  try {
    const estimatedGas = await contractAsUser.methods
      .buyMarketItem(marketItemId)
      .estimateGas({ value: price + 1 });
    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .buyMarketItem(marketItemId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: price + 1,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function getNFTDetails(authUUID, protocol) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_nft_details",
    {
      authUUID,
      protocol,
      graphURL,
      authorizationGraphURL,
      bondingCurveGraphURL,
      bondingCurveV2GraphURL,
      isMainnet: REACT_APP_IS_MAINNET !== "testnet"
    }
  );
  if(data["data"] == null) {
    return [];
  } else {
    return data["data"];
  }
}

export async function getCurrentSupply(authUUID, protocol) {
  // let query = `
  //       {
  //           item(id:${'"' + authUUID + '"'}){
  //               id,
  //               history{
  //                 wasBurn
  //               }
  //           }
  //       }
  //   `;
  //   let data = await axios.post(bondingCurveGraphURL, { query });
  //   let item = data["data"]["data"]["item"];
  //   if (item == null) {
  //     return 0;
  //   }
  //   let history = item["history"];
  //   let ans = 0;
  //   for(let i = 0; i < history.length; i++) {
  //     let historyItem = history[i];
  //     if(historyItem.wasBurn) {
  //       ans -= 1;
  //     } else {
  //       ans += 1;
  //     }
  //   }
  //   return ans;
  let usedContract;
  if(protocol === "liquid") {
    usedContract = bondingCurveContract;
  } else {
    usedContract = bondingCurveOrchestratorContract;
  }
  let pastBondingCurveMintEvents = await usedContract.getPastEvents("ItemMinted", {
    fromBlock: 0,
    toBlock: 'latest'
  });
  let pastBondingCurveBurnEvents = await usedContract.getPastEvents("ItemBurned", {
    fromBlock: 0,
    toBlock: 'latest'
  });
  let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === authUUID);
  let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === authUUID);
  return filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
}

export async function getENSForItemHistory(item) {
  let history = item.history;
  history = await Promise.all(history.map(async (historyItem) => {
    console.log(historyItem.userId);
    let ensName = await getENS(historyItem.userId);
    historyItem.displayedUserId = ensName;
    return historyItem;
  }));
  item.history = history;
  return item;
}

export async function computeCurrentPrice(tokenId, evaluatedAt, protocol) {
  let usedContract;
  if(protocol === "liquid") {
    usedContract = bondingCurveContract;
  } else {
    usedContract = bondingCurveOrchestratorContract;
  }
  let ans = await usedContract.methods
    .currentBondingPrice(tokenId, evaluatedAt)
    .call();
  return ans;
}

export async function computeMoneyInContract(tokenId, protocol) {
  let usedContract;
  if(protocol === "liquid") {
    usedContract = bondingCurveContract;
  } else {
    usedContract = bondingCurveOrchestratorContract;
  }
  let ans = await usedContract.methods
    .currentLiquidityPool(tokenId)
    .call();
  return ans;
}

export async function getBalance(address, i) {
  return await ppvContract.methods.balanceOf(address, i).call();
}

export async function getBondingCurveBalance(address, i) {
  return await bondingCurveContract.methods.balanceOf(address, i).call();
}

export async function getBondingCurveBalanceV2(contractAddress, address, i) {
  let bondingCurveContract = new web3Eth.eth.Contract(
    contract10.abi,
    contractAddress
  );
  return await bondingCurveContract.methods.balanceOf(address, i).call();
}

export async function getCrossmintBalance(userId, tokenId, isMainnet, isCreatorOwned) {
  let data = await axios.post(
    "https://1rwizepx29.execute-api.us-west-2.amazonaws.com/dev/get_token_count",
    {
      userId: userId,
      tokenId: tokenId,
      isMainnet: isMainnet,
      isCreatorOwned: isCreatorOwned
    }
  );
  if(data["data"] != null) {
    return data["data"]["count"];
  } else {
    return 0;
  }
}

export async function getMintReadyAndCompleteNFTs() {
  let query = `
        {
            items(where:{isMintReady:true}){
                id,
                creatorAddress,
                mintLimit,
                mintCount,
                isMintReady,
                isMintComplete,
                tokenCID,
                mintPrice,
                mediaType,
                tokenId
            }
        }
    `;
  let data = await axios.post(graphURL, { query });
  let items = data["data"]["data"]["items"];
  let authUUIDs = items.map((item) => '"' + item.id + '"');
  let authorizationQuery = `
        {
            items(where: {id_in:${"[" + authUUIDs + "]"}}){
                id,
                creatorShares,
                holderShares,
                impressionFee
            }
        }
    `;
  let authorizationData = await axios.post(authorizationGraphURL, {
    query: authorizationQuery,
  });
  let authorizationItems = authorizationData["data"]["data"]["items"];
  let authorizationInfo = {};
  for (let i = 0; i < authorizationItems.length; i++) {
    authorizationInfo[authorizationItems[i].id] = {
      creatorShares: authorizationItems[i].creatorShares,
      holderShares: authorizationItems[i].holderShares,
      impressionFee: authorizationItems[i].impressionFee,
    };
  }
  let ans = await Promise.all(items.map(async (item) => {
    let tokenId = item["tokenId"];
    let creatorAddress = item["creatorAddress"];
    let mintLimit = item["mintLimit"];
    let mintCount = item["mintCount"];
    let isMintReady = item["isMintReady"];
    let isMintComplete = item["isMintComplete"];
    let tokenCID = item["tokenCID"];
    let mintPrice = item["mintPrice"];
    let mediaType = item["mediaType"];
    let authUUID = item["id"];
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let metadata = await axios.get(uri);
    ans.push({
      description: metadata.data.description,
      name: metadata.data.name,
      mintPrice,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      authUUID,
      mintCount,
      mintLimit,
      isMintReady,
      isMintComplete,
      mediaType,
      impressionFee: authorizationInfo[authUUID].impressionFee,
      creatorAddress,
      tokenId,
      uri,
      royaltySharesInfo: {
        creatorShares: authorizationInfo[authUUID].creatorShares,
        holderShares: authorizationInfo[authUUID].holderShares,
      },
    });
  }));
  return ans;
}

export async function getStreamerProfileInfo(creatorName) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_streamer_profile_info",
    {
      creatorName
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    let ans = data["data"];
    for(let i = 0; i < Object.keys(ans["socials"]).length; i++) {
      let key = Object.keys(ans["socials"])[i];
      let val = ans["socials"][key];
      if(val == null) {
        continue;
      }
      let strippedUrl = val;
      strippedUrl = strippedUrl.replace("https://", "");
      strippedUrl = strippedUrl.replace("http://", "");
      strippedUrl = strippedUrl.replace("www.", "");
      if(key === "spotify") {
        ans["socials"][key] = "https://" + strippedUrl;
      } else {
        ans["socials"][key] = "https://www." + strippedUrl;
      }
    }
    return data["data"];
  }
}

export async function updateStreamerProfileInfo(name, address, info) {
  await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/put_streamer_profile_info",
    {
      name,
      address,
      info
    }
  );
}

export async function getUserProfileInfo(address) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_user_info",
    {
      address
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    return data["data"];
  }
}

export async function getUserOwnedNFTImages(address) {
  if(!address.includes("0x")) {
    return [];
  }
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_all_user_nft_images",
    {
      address
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    return data["data"];
  }
}

export async function updateUserProfileInfo(address, username, pfp, isNFTPFP) {
  await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/update_user_info",
    {
      address,
      username,
      pfp,
      isNFTPFP
    }
  );
}

export async function logMinuteAttended(creatorAddress, viewerAddress) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/put_minute_attended",
    {
      creatorAddress,
      viewerAddress
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    return data["data"];
  }
}

export async function logMicropayment(creatorAddress, viewerAddress, amount) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/put_micropayment",
    {
      creatorAddress,
      viewerAddress,
      amount
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    return data["data"];
  }
}

export async function getBadgeInfo(creatorAddress, viewerAddress) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_badge_info",
    {
      creatorAddress,
      viewerAddress
    }
  );
  if(data["data"] == null) {
    return {};
  } else {
    return data["data"];
  }
}

export async function getMintReadyNFTs(mediaTypes) {
  let data = await axios.post(
    "https://f1whlelx7f.execute-api.us-west-2.amazonaws.com/dev/get_mint_ready_nfts",
    {
      mediaTypes,
      graphURL,
      authorizationGraphURL,
      bondingCurveGraphURL,
      bondingCurveV2GraphURL,
      isMainnet: REACT_APP_IS_MAINNET !== "testnet"
    }
  );
  if(data["data"] == null) {
    return [];
  } else {
    return data["data"];
  }
}

export async function getMintFinishedNFTs(mediaType) {
  let query = `
        {
            items(where:{isMintComplete:true}){
                id,
                creatorAddress,
                mintLimit,
                mintCount,
                isMintReady,
                isMintComplete,
                tokenCID,
                mintPrice,
                mediaType,
                tokenId
            }
        }
    `;
  let data = await axios.post(graphURL, { query });
  let items = data["data"]["data"]["items"];
  let authUUIDs = items.map((item) => '"' + item.id + '"');
  let authorizationQuery = `
        {
            items(where: {id_in:${"[" + authUUIDs + "]"}}){
                id,
                creatorShares,
                holderShares,
                impressionFee
            }
        }
    `;
  let authorizationData = await axios.post(authorizationGraphURL, {
    query: authorizationQuery,
  });
  let authorizationItems = authorizationData["data"]["data"]["items"];
  let authorizationInfo = {};
  for (let i = 0; i < authorizationItems.length; i++) {
    authorizationInfo[authorizationItems[i].id] = {
      creatorShares: authorizationItems[i].creatorShares,
      holderShares: authorizationItems[i].holderShares,
      impressionFee: authorizationItems[i].impressionFee,
    };
  }
  let ans = await Promise.all(items.map(async (item) => {
    let tokenId = item["tokenId"];
    let creatorAddress = item["creatorAddress"];
    let mintLimit = item["mintLimit"];
    let mintCount = item["mintCount"];
    let isMintReady = item["isMintReady"];
    let isMintComplete = item["isMintComplete"];
    let tokenCID = item["tokenCID"];
    let authUUID = item["id"];
    let mintPrice = item["mintPrice"];
    let itemMediaType = item["mediaType"];
    if (itemMediaType.toString() !== mediaType.toString()) {
      return null;
    }
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let metadata = await axios.get(uri);
    console.log(authUUID);
    console.log(authorizationInfo[authUUID]);
    return {
      description: metadata.data.description,
      name: metadata.data.name,
      mintPrice,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      authUUID,
      mintCount,
      mintLimit,
      isMintReady,
      isMintComplete,
      mediaType: itemMediaType,
      impressionFee: authorizationInfo[authUUID].impressionFee,
      creatorAddress,
      creatorName: metadata.data.creatorName,
      tokenId,
      tokenCID,
      uri,
      royaltySharesInfo: {
        creatorShares: authorizationInfo[authUUID].creatorShares,
        holderShares: authorizationInfo[authUUID].holderShares,
      },
      protocol: "the402",
    };
  }));
  ans = ans.filter(x => x);
  return ans;
}

export async function getCurrentlyListedNFTs(address) {
  address = address.toLowerCase();
  let query = `
      {
        marketplaceItems(where:{seller:${'"' + address + '"'}}){
          id,
          item{
            id
          },
          delisted,
          price,
          amount,
          sold
        }
      }
    `;
  let data = await axios.post(graphURL, { query });
  let items = data["data"]["data"]["marketplaceItems"];
  let ans = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].delisted || items[i].sold) {
      continue;
    }
    ans.push({
      marketItemId: items[i].id,
      authUUID: items[i].item.id,
      price: items[i].price,
      amount: items[i].amount,
      protocol: "the402",
    });
  }
  let bondingCurveQuery = `
      {
        marketplaceItems(where:{seller:${'"' + address + '"'}}){
          id,
          item{
            id
          },
          delisted,
          price,
          amount,
          sold
        }
      }
    `;
  let bondingCurveData = await axios.post(bondingCurveGraphURL, {
    query: bondingCurveQuery,
  });
  let bondingCurveItems = bondingCurveData["data"]["data"]["marketplaceItems"];
  for (let i = 0; i < bondingCurveItems.length; i++) {
    if (bondingCurveItems[i].delisted || bondingCurveItems[i].sold) {
      continue;
    }
    ans.push({
      marketItemId: bondingCurveItems[i].id,
      authUUID: bondingCurveItems[i].item.id,
      price: bondingCurveItems[i].price,
      amount: bondingCurveItems[i].amount,
      protocol: "liquid",
    });
  }
  return ans;
}

export async function getHeldNFTs(address) {
  address = address.toLowerCase();
  let query = `
        {
            user(id:${'"' + address + '"'}){
                ownedItems{
                    item{
                        id,
                        creatorAddress,
                        mintLimit,
                        mintCount,
                        isMintReady,
                        isMintComplete,
                        tokenCID,
                        mintPrice,
                        mediaType,
                        tokenId
                    },
                    editionsOwned
                }
            }
        }
    `;
  let data = await axios.post(graphURL, { query });
  let user = data["data"]["data"]["user"];
  let ans = [];
  if (user != null) {
    let items = user["ownedItems"];
    let authUUIDs = items.map((item) => '"' + item.item.id + '"');
    let authorizationQuery = `
          {
              items(where: {id_in:${"[" + authUUIDs + "]"}}){
                  id,
                  creatorShares,
                  holderShares,
                  impressionFee
              }
          }
      `;
    let authorizationData = await axios.post(authorizationGraphURL, {
      query: authorizationQuery,
    });
    let authorizationItems = authorizationData["data"]["data"]["items"];
    let authorizationInfo = {};
    for (let i = 0; i < authorizationItems.length; i++) {
      authorizationInfo[authorizationItems[i].id] = {
        creatorShares: authorizationItems[i].creatorShares,
        holderShares: authorizationItems[i].holderShares,
        impressionFee: authorizationItems[i].impressionFee,
      };
    }
    let newAns = await Promise.all(items.map(async (outerItem) => {
      let item = outerItem["item"];
      let tokenId = item["tokenId"];
      let creatorAddress = item["creatorAddress"];
      let mintLimit = item["mintLimit"];
      let mintCount = item["mintCount"];
      let isMintReady = item["isMintReady"];
      let isMintComplete = item["isMintComplete"];
      let tokenCID = item["tokenCID"];
      let mintPrice = item["mintPrice"];
      let mediaType = item["mediaType"];
      let authUUID = item["id"];
      let balance = outerItem["editionsOwned"];
      let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
      let metadata = await axios.get(uri);
      ans.push({
        description: metadata.data.description,
        name: metadata.data.name,
        authUUID,
        balance,
        mintPrice,
        imagePinata: metadata.data.imagePinata,
        image: metadata.data.image,
        royalty: metadata.data.creatorRoyaltyPercentage,
        mintCount,
        mintLimit,
        isMintReady,
        isMintComplete,
        mediaType,
        impressionFee: authorizationInfo[authUUID].impressionFee,
        creatorAddress,
        tokenId,
        uri,
        royaltySharesInfo: {
          creatorShares: authorizationInfo[authUUID].creatorShares,
          holderShares: authorizationInfo[authUUID].holderShares,
        },
        protocol: "the402",
      });
    }));
    ans = ans.concat(newAns);
  }
  let bondingCurveQuery = `
        {
            user(id:${'"' + address + '"'}){
                ownedItems{
                    item{
                      id,
                      creatorAddress,
                      currentSupply,
                      isMintReady,
                      tokenCID,
                      parameters,
                      mediaType,
                      tokenId,
                      isSigmoid,
                      liquidityPeriodStart,
                      liquidityPeriodLength,
                      currentBuyFeePerThousand,
                      currentSellFeePerThousand
                    },
                    editionsOwned
                }
            }
        }
    `;
  let bondingCurveData = await axios.post(bondingCurveGraphURL, {
    query: bondingCurveQuery,
  });
  let bondingCurveUser = bondingCurveData["data"]["data"]["user"];
  if (bondingCurveUser != null) {
    let bondingCurveItems = bondingCurveUser["ownedItems"];
    let newAns = await Promise.all(bondingCurveItems.map(async (bondingCurveItem) => {
      let item = bondingCurveItem["item"];
      let tokenId = item["tokenId"];
      let authUUID = item["id"];
      let balance = bondingCurveItem["editionsOwned"];
      let creatorAddress = item["creatorAddress"];
      let currentSupply = await getCurrentSupply(item["id"], "liquid");
      let isMintReady = item["isMintReady"];
      let tokenCID = item["tokenCID"];
      let isSigmoid = item["isSigmoid"];
      let parameters = item["parameters"];
      let itemMediaType = item["mediaType"];
      let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
      let liquidityPeriodStart = item["liquidityPeriodStart"];
      let liquidityPeriodLength = item["liquidityPeriodLength"];
      let metadata = await axios.get(uri);
      let currentBuyPrice = await computeCurrentPrice(tokenId, currentSupply + 1, "liquid");
      let currentSellPrice = await computeCurrentPrice(tokenId, currentSupply, "liquid");
      let moneyInContract = await computeMoneyInContract(tokenId, "liquid");
      let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
      let currentSellFeePerThousand = item["currentSellFeePerThousand"];
      let baseBuyPrice = currentBuyPrice;
      let baseSellPrice = currentSellPrice;
      currentBuyPrice = Math.ceil(currentBuyPrice * (1 + currentBuyFeePerThousand/1000))*1.0005;
      currentSellPrice = Math.floor(currentSellPrice * (1 - currentSellFeePerThousand/1000));
      return {
        description: metadata.data.description,
        name: metadata.data.name,
        imagePinata: metadata.data.imagePinata,
        image: metadata.data.image,
        royalty: metadata.data.creatorRoyaltyPercentage,
        authUUID,
        currentSupply,
        isMintReady,
        balance,
        mediaType: itemMediaType,
        impressionFee: 0,
        creatorAddress,
        tokenId,
        uri,
        holderShares: 0,
        royaltySharesInfo: {
          creatorShares: 0,
          holderShares: 0,
        },
        parameters,
        isSigmoid,
        liquidityPeriodLength,
        liquidityPeriodStart,
        baseBuyPrice,
        baseSellPrice,
        mintPrice: currentBuyPrice,
        sellPrice: currentSellPrice,
        protocol: "liquid",
        currentBuyFeePerThousand,
        currentSellFeePerThousand,
        moneyInContract,
      };
    }));
    ans = ans.concat(newAns);
  }
  let bondingCurveV2Query = `
        {
            user(id:${'"' + address + '"'}){
                ownedItems{
                    item{
                      id,
                      creatorAddress,
                      currentSupply,
                      isMintReady,
                      tokenCID,
                      parameters,
                      mediaType,
                      tokenId,
                      isSigmoid,
                      liquidityPeriodStart,
                      liquidityPeriodLength,
                      currentBuyFeePerThousand,
                      currentSellFeePerThousand,
                      tokenContractAddress
                    },
                    editionsOwned
                }
            }
        }
    `;
  let bondingCurveV2Data = await axios.post(bondingCurveV2GraphURL, {
    query: bondingCurveV2Query,
  });
  let bondingCurveV2User = bondingCurveV2Data["data"]["data"]["user"];
  if (bondingCurveV2User != null) {
    let bondingCurveV2Items = bondingCurveV2User["ownedItems"];
    let newAns = await Promise.all(bondingCurveV2Items.map(async (bondingCurveItem) => {
      let item = bondingCurveItem["item"];
      let tokenId = item["tokenId"];
      let authUUID = item["id"];
      let balance = bondingCurveItem["editionsOwned"];
      let creatorAddress = item["creatorAddress"];
      let currentSupply = await getCurrentSupply(item["id"], "liquidv2");
      let isMintReady = item["isMintReady"];
      let tokenCID = item["tokenCID"];
      let isSigmoid = item["isSigmoid"];
      let parameters = item["parameters"];
      let itemMediaType = item["mediaType"];
      let tokenContractAddress = item["tokenContractAddress"];
      let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
      let liquidityPeriodStart = item["liquidityPeriodStart"];
      let liquidityPeriodLength = item["liquidityPeriodLength"];
      let metadata = await axios.get(uri);
      let currentBuyPrice = await computeCurrentPrice(tokenId, currentSupply + 1, "liquidv2");
      let currentSellPrice = await computeCurrentPrice(tokenId, currentSupply, "liquidv2");
      let moneyInContract = await computeMoneyInContract(tokenId, "liquidv2");
      let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
      let currentSellFeePerThousand = item["currentSellFeePerThousand"];
      let baseBuyPrice = currentBuyPrice;
      let baseSellPrice = currentSellPrice;
      currentBuyPrice = Math.ceil(currentBuyPrice * (1 + currentBuyFeePerThousand/1000))*1.0005;
      currentSellPrice = Math.floor(currentSellPrice * (1 - currentSellFeePerThousand/1000));
      return {
        description: metadata.data.description,
        name: metadata.data.name,
        imagePinata: metadata.data.imagePinata,
        image: metadata.data.image,
        authUUID,
        currentSupply,
        isMintReady,
        balance,
        mediaType: itemMediaType,
        impressionFee: 0,
        creatorAddress,
        tokenContractAddress,
        tokenId,
        uri,
        holderShares: 0,
        royaltySharesInfo: {
          creatorShares: 0,
          holderShares: 0,
        },
        parameters,
        isSigmoid,
        liquidityPeriodLength,
        liquidityPeriodStart,
        baseBuyPrice,
        baseSellPrice,
        mintPrice: currentBuyPrice,
        sellPrice: currentSellPrice,
        protocol: "liquidv2",
        currentBuyFeePerThousand,
        currentSellFeePerThousand,
        moneyInContract,
      };
    }));
    ans = ans.concat(newAns);
  }
  return ans;
}

export async function getCreatedNFTs(address) {
  address = address.toLowerCase();
  let query = `
        {
            items(where:{creatorAddress:${'"' + address + '"'}}){
                id,
                creatorAddress,
                mintLimit,
                mintCount,
                isMintReady,
                isMintComplete,
                tokenCID,
                mintPrice,
                mediaType,
                tokenId
            }
        }
    `;
  let data = await axios.post(graphURL, { query });
  let items = data["data"]["data"]["items"];
  let authUUIDs = items.map((item) => '"' + item.id + '"');
  let authorizationQuery = `
        {
            items(where: {id_in:${"[" + authUUIDs + "]"}}){
                id,
                creatorShares,
                holderShares,
                impressionFee
            }
        }
    `;
  let authorizationData = await axios.post(authorizationGraphURL, {
    query: authorizationQuery,
  });
  let authorizationItems = authorizationData["data"]["data"]["items"];
  let authorizationInfo = {};
  for (let i = 0; i < authorizationItems.length; i++) {
    authorizationInfo[authorizationItems[i].id] = {
      creatorShares: authorizationItems[i].creatorShares,
      holderShares: authorizationItems[i].holderShares,
      impressionFee: authorizationItems[i].impressionFee,
    };
  }
  let ans = await Promise.all(items.map(async (item) => {
    let tokenId = item["tokenId"];
    let creatorAddress = item["creatorAddress"];
    let mintLimit = item["mintLimit"];
    let mintCount = item["mintCount"];
    let isMintReady = item["isMintReady"];
    let isMintComplete = item["isMintComplete"];
    let tokenCID = item["tokenCID"];
    let mintPrice = item["mintPrice"];
    let mediaType = item["mediaType"];
    let authUUID = item["id"];
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let metadata = await axios.get(uri);
    return {
      description: metadata.data.description,
      name: metadata.data.name,
      authUUID,
      mintPrice,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      mintCount,
      mintLimit,
      isMintReady,
      isMintComplete,
      mediaType,
      impressionFee: authorizationInfo[authUUID].impressionFee,
      creatorAddress,
      displayedCreatorAddress: creatorAddress.substring(0, 5) + "..." + creatorAddress.substring(creatorAddress.length - 5),
      tokenId,
      uri,
      protocol: "the402",
      royaltySharesInfo: {
        creatorShares: authorizationInfo[authUUID].creatorShares,
        holderShares: authorizationInfo[authUUID].holderShares,
      },
    };
  }));
  let bondingCurveQuery = `
        {
            items(where:{creatorAddress:${'"' + address + '"'}}){
              id,
              creatorAddress,
              currentSupply,
              isMintReady,
              tokenCID,
              parameters,
              mediaType,
              tokenId,
              isSigmoid,
              liquidityPeriodStart,
              liquidityPeriodLength,
              currentBuyFeePerThousand,
              currentSellFeePerThousand
            }
        }
    `;let bondingCurveData = await axios.post(bondingCurveGraphURL, {
    query: bondingCurveQuery,
  });
  let bondingCurveItems = bondingCurveData["data"]["data"]["items"];
  let bondingCurveItemsWithData = await Promise.all(bondingCurveItems.map(async (item) => {
    let tokenId = item["tokenId"];
    let creatorAddress = item["creatorAddress"];
    let currentSupply = await getCurrentSupply(item["id"], "liquid");
    let isMintReady = item["isMintReady"];
    let tokenCID = item["tokenCID"];
    let parameters = item["parameters"];
    let authUUID = item["id"];
    let isSigmoid = item["isSigmoid"];
    let itemMediaType = item["mediaType"];
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let liquidityPeriodStart = item["liquidityPeriodStart"];
    let liquidityPeriodLength = item["liquidityPeriodLength"];
    let metadata = await axios.get(uri);
    let currentBuyPrice = await computeCurrentPrice(tokenId, currentSupply + 1, "liquid");
    let currentSellPrice = await computeCurrentPrice(tokenId, currentSupply, "liquid");
    let moneyInContract = await computeMoneyInContract(tokenId, "liquid");
    let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
    let currentSellFeePerThousand = item["currentSellFeePerThousand"];
    let baseBuyPrice = currentBuyPrice;
    let baseSellPrice = currentSellPrice;
    currentBuyPrice = Math.ceil(currentBuyPrice * (1 + currentBuyFeePerThousand/1000))*1.0005;
    currentSellPrice = Math.floor(currentSellPrice * (1 - currentSellFeePerThousand/1000));
    let animation_url = metadata.data.animation_url;
    if(animation_url === "https://the402.mypinata.cloud/ipfs/QmRJ7PBo9sVnK66NESagiJwgC8vXRdyayFqyRHpjYTXzRS") {
      animation_url = "https://the402open.mypinata.cloud/ipfs/QmPF2evTQrNEcorBRsad6MLASEnAbviRpuadx1Lczsz4dQ";
    }
    return {
      animation_url: animation_url,
      description: metadata.data.description,
      name: metadata.data.name,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      authUUID,
      currentSupply,
      isMintReady,
      mediaType: itemMediaType,
      impressionFee: 0,
      creatorAddress,
      displayedCreatorAddress: creatorAddress.substring(0, 5) + "..." + creatorAddress.substring(creatorAddress.length - 5),
      tokenId,
      uri,
      parameters,
      isSigmoid,
      liquidityPeriodLength,
      liquidityPeriodStart,
      baseBuyPrice,
      baseSellPrice,
      mintPrice: currentBuyPrice,
      sellPrice: currentSellPrice,
      protocol: "liquid",
      currentBuyFeePerThousand,
      currentSellFeePerThousand,
      moneyInContract,
      creatorName: metadata.data.creatorName,
    };
  }));
  // TODO support created NFTs liquidv2
  ans.push(...bondingCurveItemsWithData);
  return ans;
}

export async function getMarketItems() {
  let query = `
        {
            marketplaceItems{
                id,
                item {
                    id,
                    tokenCID,
                    mediaType
                },
                seller {
                    id
                },
                price,
                amount,
                delisted,
                sold
            }
        }
    `;
  let data = await axios.post(graphURL, { query });
  let items = data["data"]["data"]["marketplaceItems"];
  let ans = await Promise.all(items.map(async (marketItem) => {
    let marketItemId = marketItem["id"];
    let sellerAddress = marketItem["seller"]["id"];
    let price = marketItem["price"];
    let authUUID = marketItem["item"]["id"];
    let tokenCID = marketItem["item"]["tokenCID"];
    let delisted = marketItem["delisted"];
    let sold = marketItem["sold"];
    let amount = marketItem["amount"];
    let itemMediaType = marketItem["item"]["mediaType"];
    if (delisted || sold) {
      return null;
    }
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let metadata = await axios.get(uri);
    return {
      description: metadata.data.description,
      name: metadata.data.name,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      mediaType: itemMediaType,
      marketItemId,
      authUUID,
      uri,
      sellerAddress,
      price,
      delisted,
      sold,
      amount,
      protocol: "the402",
    };
  }));
  ans = ans.filter(x => x);
  let bondingCurveQuery = `
        {
            marketplaceItems{
                id,
                item {
                    id,
                    tokenCID,
                    mediaType
                },
                seller {
                    id
                },
                price,
                amount,
                delisted,
                sold
            }
        }
    `;
  let bondingCurveData = await axios.post(bondingCurveGraphURL, {
    query: bondingCurveQuery,
  });
  let bondingCurveItems = bondingCurveData["data"]["data"]["marketplaceItems"];
  let newAns = await Promise.all(bondingCurveItems.map(async (marketItem) => {
    let marketItemId = marketItem["id"];
    let sellerAddress = marketItem["seller"]["id"];
    let price = marketItem["price"];
    let authUUID = marketItem["item"]["id"];
    let tokenCID = marketItem["item"]["tokenCID"];
    let delisted = marketItem["delisted"];
    let sold = marketItem["sold"];
    let amount = marketItem["amount"];
    let itemMediaType = marketItem["item"]["mediaType"];
    if (delisted || sold) {
      return null;
    }
    let uri = "https://the402.mypinata.cloud/ipfs/" + tokenCID;
    let metadata = await axios.get(uri);
    return {
      description: metadata.data.description,
      name: metadata.data.name,
      imagePinata: metadata.data.imagePinata,
      image: metadata.data.image,
      royalty: metadata.data.creatorRoyaltyPercentage,
      mediaType: itemMediaType,
      marketItemId,
      authUUID,
      uri,
      sellerAddress,
      price,
      delisted,
      sold,
      amount,
      protocol: "liquid",
    };
  }));
  newAns = newAns.filter(x => x);
  ans = ans.concat(newAns);
  return ans;
}

export async function getNounsCollectionDetails(collectionId) {
  let query = `
    {
      collection(id:${'"' + collectionId + '"'}){
        id
        allAuctions {
          id,
          nounId,
          amount,
          startTime,
          endTime,
          bidder,
          settled,
          allAuctionBids{
            id,
            bidder,
            amount,
            transactionHash
          }
        },
        tokenContractAddress,
        latestAuction {
          id,
          nounId,
          amount,
          startTime,
          endTime,
          bidder,
          settled,
          allAuctionBids{
            id,
            bidder,
            amount,
            transactionHash
          }
        }
        reservePrice,
        duration,
        collectionSize,
        creatorAddress,
      }
    }
  `;
  let data = await axios.post(nounsGraphURL, { query });
  let item = data["data"]["data"]["collection"];
  if (item == null) {
    return null;
  }
  let treasury = 0;
  for(let i = 0; i < item["allAuctions"].length; i++) {
    let auction = item["allAuctions"][i];
    if(auction["settled"]) {
      treasury += parseInt(auction["amount"])/1000000000000000000;
    }
  }
  item["treasury"] = treasury;
  let allAuctions = item["allAuctions"];
  allAuctions = await Promise.all(allAuctions.map(async (auction) => {
    let details = await getNounDetails(item["tokenContractAddress"], parseInt(auction["nounId"]));
    auction.imagePinata = details.imagePinata;
    auction.name = details.name;
    auction.animation_url = details.animation_url;
    auction.description = details.description;
    auction.mediaType = details.mediaType;
    return auction;
  }));
  for(let i = 0; i < item["allAuctions"].length; i++) {
    let auction = item["allAuctions"][i];
    auction.reservePrice = item.reservePrice;
  }
  item["allAuctions"] = allAuctions;
  if(item["latestAuction"] != null) {
    let auction = item["latestAuction"];
    let details = await getNounDetails(item["tokenContractAddress"], parseInt(auction["nounId"]));
    auction.imagePinata = details.imagePinata;
    auction.name = details.name;
    auction.animation_url = details.animation_url;
    auction.description = details.description;
    auction.mediaType = details.mediaType;
    auction.reservePrice = item.reservePrice;
    auction.tokenContractAddress = item.tokenContractAddress;
    item["latestAuction"] = auction;
  }
  return item;
}

export async function getAllNounsCollectionDetails() {
  let query = `
    {
      collections{
        id
        allAuctions {
          id,
          nounId,
          amount,
          startTime,
          endTime,
          bidder,
          settled,
          allAuctionBids{
            id,
            bidder,
            amount,
            transactionHash
          }
        },
        tokenContractAddress,
        latestAuction {
          id,
          nounId,
          amount,
          startTime,
          endTime,
          bidder,
          settled,
          allAuctionBids{
            id,
            bidder,
            amount,
            transactionHash
          }
        }
        reservePrice,
        duration,
        collectionSize,
        creatorAddress,
      }
    }
  `;
  let data = await axios.post(nounsGraphURL, { query });
  let items = data["data"]["data"]["collections"];
  if (items == null || items.length === 0) {
    return [];
  }

  let featuredItem = items[0];
  let allAuctions = featuredItem["allAuctions"];
  allAuctions = await Promise.all(allAuctions.map(async (auction) => {
    let details = await getNounDetails(featuredItem["tokenContractAddress"], parseInt(auction["nounId"]));
    auction.imagePinata = details.imagePinata;
    auction.name = details.name;
    auction.animation_url = details.animation_url;
    auction.description = details.description;
    auction.mediaType = details.mediaType;
    auction.reservePrice = featuredItem.reservePrice;
    return auction;
  }));
  featuredItem["allAuctions"] = allAuctions;
  if(featuredItem["latestAuction"] != null) {
    let auction = featuredItem["latestAuction"];
    let details = await getNounDetails(featuredItem["tokenContractAddress"], parseInt(auction["nounId"]));
    auction.imagePinata = details.imagePinata;
    auction.name = details.name;
    auction.animation_url = details.animation_url;
    auction.description = details.description;
    auction.mediaType = details.mediaType;
    auction.reservePrice = featuredItem.reservePrice;
    auction.tokenContractAddress = featuredItem.tokenContractAddress;
    featuredItem["latestAuction"] = auction;
  }
  items[0] = featuredItem;
  items = await Promise.all(items.map(async (item) => {
    if(item["latestAuction"] != null) {
      let auction = item["latestAuction"];
      let details = await getNounDetails(item["tokenContractAddress"], parseInt(auction["nounId"]));
      auction.imagePinata = details.imagePinata;
      auction.name = details.name;
      auction.animation_url = details.animation_url;
      auction.description = details.description;
      auction.mediaType = details.mediaType;
      auction.reservePrice = item.reservePrice;
      auction.tokenContractAddress = item.tokenContractAddress;
      item["latestAuction"] = auction;
    }
    return item;
  }));
  return items;
}

export async function getNounDetails(contractAddress, nounId) {
  let nounsTokenContract;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    nounsTokenContract = new web3Eth.eth.Contract(
      contract6.abi,
      contractAddress
    );
  } else {
    nounsTokenContract = new web3Eth.eth.Contract(
      contract6.abi,
      contractAddress
    );
  }
  let tokenURI = await nounsTokenContract.methods.tokenURI(nounId).call();
  let metadata = await axios.get(tokenURI);
  return {
    "name": metadata.data.name,
    "imagePinata": metadata.data.imagePinata,
    "animation_url": metadata.data.animation_url,
    "description": metadata.data.description,
    "mediaType": "mediaType" in metadata.data ? metadata.data.mediaType : 2
  }
}

export async function startFirstAuction(publicKey, collectionDetails) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetNounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = nounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let nounsAuctionHouseContractAsUser = new web3Eth.eth.Contract(
    contract7.abi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );

  let data = await axios.post(
    "https://wnswa94u31.execute-api.us-west-2.amazonaws.com/dev/retrieve_appropriate_info_from_db",
    {
      tokenContractAddress: collectionDetails.tokenContractAddress,
      isMainnet: REACT_APP_IS_MAINNET !== "testnet"
    }
  );
  if(data["data"] == null) {
    return false;
  }

  let tokenCID = data["data"]["tokenCIDToReturn"];
  let merkleProof = data["data"]["hexProof"];

  try {
    const estimatedGas = await nounsAuctionHouseContractAsUser.methods
      .unpause(parseInt(collectionDetails.id), tokenCID, merkleProof)
      .estimateGas();
    let sendTxPromise = new Promise(function (resolve, reject) {
      nounsAuctionHouseContractAsUser.methods
        .unpause(parseInt(collectionDetails.id), tokenCID, merkleProof)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function placeBid(publicKey, auction, bidAmount) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetNounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = nounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let nounsAuctionHouseContractAsUser = new web3Eth.eth.Contract(
    contract7.abi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );
  let collectionId = parseInt(auction.id.split("_")[0]);
  let nounId = parseInt(auction["nounId"]);

  try {
    const estimatedGas = await nounsAuctionHouseContractAsUser.methods
      .createBid(collectionId, nounId)
      .estimateGas({value: bidAmount*1000000000000000000});
    let sendTxPromise = new Promise(function (resolve, reject) {
      nounsAuctionHouseContractAsUser.methods
        .createBid(collectionId, nounId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          value: bidAmount*1000000000000000000,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function settleBid(publicKey, auction) {
  const maxGasPrice = await getCurrentEthGasPrice();
  let provider = await getProvider();
  let usedContractAddress;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetNounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = nounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let nounsAuctionHouseContractAsUser = new web3Eth.eth.Contract(
    contract7.abi,
    usedContractAddress,
    {
      from: publicKey,
    }
  );
  let collectionId = parseInt(auction.id.split("_")[0]);
  let data = await axios.post(
    "https://wnswa94u31.execute-api.us-west-2.amazonaws.com/dev/retrieve_appropriate_info_from_db",
    {
      tokenContractAddress: auction.tokenContractAddress,
      isMainnet: REACT_APP_IS_MAINNET !== "testnet"
    }
  );
  if(data["data"] == null) {
    // Either need to keep going on current auction or item simply doesn't exist
    return false;
  }

  let tokenCID = data["data"]["tokenCIDToReturn"];
  let merkleProof = data["data"]["hexProof"];

  try {
    let estimatedGas;
    let sendTxPromise;
    if(tokenCID != null) {
      estimatedGas = await nounsAuctionHouseContractAsUser.methods
        .settleCurrentAndCreateNewAuction(collectionId, tokenCID, merkleProof)
        .estimateGas();
      sendTxPromise = new Promise(function (resolve, reject) {
        nounsAuctionHouseContractAsUser.methods
          .settleCurrentAndCreateNewAuction(collectionId, tokenCID, merkleProof)
          .send({
            from: publicKey,
            gas: parseInt(estimatedGas * 1.03),
            maxPriorityFeePerGas: maxGasPrice,
            chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
          })
          .on("confirmation", function (hash) {
            resolve(true);
          })
          .on("error", function (error, receipt) {
            resolve(false);
          });
      });
    } else {
      estimatedGas = await nounsAuctionHouseContractAsUser.methods
        .settleAuction(collectionId)
        .estimateGas();
      sendTxPromise = new Promise(function (resolve, reject) {
        nounsAuctionHouseContractAsUser.methods
          .settleAuction(collectionId)
          .send({
            from: publicKey,
            gas: parseInt(estimatedGas * 1.03),
            maxPriorityFeePerGas: maxGasPrice,
            chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
          })
          .on("confirmation", function (hash) {
            resolve(true);
          })
          .on("error", function (error, receipt) {
            resolve(false);
          });
      });
    }
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function postEncryptedData(itemParams) {
  const url = "https://x9b60b84la.execute-api.us-west-2.amazonaws.com/dev";

  return await axios.post(url + "/post_encrypted_data", itemParams);
}

export async function getEncryptedItems(authSig) {
  const url = "https://x9b60b84la.execute-api.us-west-2.amazonaws.com/dev";

  return await axios.post(url + "/get_encrypted_data", {
    creatorAddress: authSig,
  });
}

export async function deleteEncryptedItems(creatorAddress, authSig, name) {
  const url = "https://x9b60b84la.execute-api.us-west-2.amazonaws.com/dev";

  return await axios.post(url + "/delete_encrypted_data", {
    creatorAddress: creatorAddress,
    name: name,
    authSig: authSig,
  });
}

export async function postFile(fileItem, key) {
  let itemURL = "https://ppv-nft-files.s3.us-west-2.amazonaws.com/";
  const REGION = "us-west-2";

  const client = new S3Client({
    region: REGION,
    credentials: fromCognitoIdentityPool({
      client: new CognitoIdentityClient({ region: REGION }),
      identityPoolId: "us-west-2:c986c479-bd11-43a0-a491-d49ee88f9f32",
      secretAccessKey: "LwpWCjQS1uyRDec5ixneSTma98uxHDJgOIpP7RyM",
      accessKeyId: "AKIA3U6SIGBW6WEYMJ4Z",
    }),
  });

  let putParams = {
    Bucket: "ppv-nft-files",
    Key: key,
    Body: fileItem,
  };

  console.log(putParams);

  await client
    .send(new PutObjectCommand(putParams))
    .then(function (response) {
      console.log(
        "Successfully created " +
          putParams.Key +
          " and uploaded it to " +
          putParams.Bucket +
          "/" +
          putParams.Key
      );
      itemURL += key;
    })
    .catch(function (error) {
      console.log("Error", error);
    });

  return itemURL;
}

export async function getShouldShowLiveStreamForVODs(viewerAddress, items, creatorAddress) {
  return await Promise.all(items.map(async (item) => {
    return await getShouldShowLivestreamForVOD(viewerAddress, item, creatorAddress);
  }));
}

export async function getShouldShowLivestreamForVOD(viewerAddress, item, creatorAddress) {
  // TODO remove Dosa, ravi, Superfest allowlist everyone
  if(
    creatorAddress.toLowerCase() === "0x8b7d4d94cb94b359b37eeb9a43872f869f74164e" ||
    creatorAddress.toLowerCase() === "0x5561974f0d35d8c355241a5568894df7b691bb28" ||
    creatorAddress.toLowerCase() === "0xcdd06e05915783f24a1333d00735923d5fcd0a65"
  ) {
    return true;
  }
  let shouldShowLiveStream = false;
  let balance = 0;
  if(viewerAddress.toLowerCase() === creatorAddress.toLowerCase()) {
    shouldShowLiveStream = true;
  } else {
    // TODO add support for livestreams on other protocols later
    if(viewerAddress !== "" && item != null && item["protocol"] === "liquid") {
      balance = await getBondingCurveBalance(viewerAddress, item["tokenId"]);
    } else if(viewerAddress !== "" && item != null && item["protocol"] === "liquidv2") {
      balance = await getBondingCurveBalanceV2(
        item["tokenContractAddress"],
        viewerAddress,
        item["collectionId"]
      );
    }
    if(balance > 0) {
      shouldShowLiveStream = true;
    }
  }
  if(item != null) {
    let crossmintUserId = getCrossmintUserId();
    let crossmintTokenBalance = await getCrossmintBalance(
      crossmintUserId,
      item.tokenId,
      process.env.REACT_APP_IS_MAINNET !== "testnet",
      item.protocol === "liquidv2"
    );
    if(crossmintTokenBalance > 0) {
      shouldShowLiveStream = true;
    }
  }
  if(
    (
      viewerAddress.toLowerCase() === "0x2fe9ec0c2ada80b61fd07fc5c35004b9e5c83a3b" ||
      viewerAddress.toLowerCase() === "0x5561974f0d35d8c355241a5568894df7b691bb28" ||
      viewerAddress.toLowerCase() === "0x10d0b1df6894b6acf9b00d921b0705ef10504564" ||
      viewerAddress.toLowerCase() === "0xd8f5ba4b9b6f29b9b4aca3cdc3b46bf5bcc9b7ed"
    )
  ) {
    shouldShowLiveStream = true;
  }
  // TODO remove Ahmed gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "6655ae00-9add-4137-bc8d-1b498e309c65") {
    let ownsOldNFT = await doesOwnOldNFT(
      ["0x22A2e9EA1721944D987e63f530d28DAAfF28e0CF"],
      [-1],
      [false],
      viewerAddress
    );
    ownsOldNFT = ownsOldNFT ||
    viewerAddress.toLowerCase() === "0x92aca8efb4d3707ed3463b962d8c2f50ae37fe43" ||
    viewerAddress.toLowerCase() === "0xd8f5ba4b9b6f29b9b4aca3cdc3b46bf5bcc9b7ed";
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove Taylor gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "59f978fd-45ce-4093-b490-17a148d5f6e9") {
    let ownsOldNFT = viewerAddress.toLowerCase() === "0x40d65ec8870d0fca1197593291f873fb0b3787db";
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove X&ND gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "687a1c6f-ddc9-4e8a-b16a-3b0ccec36ebb") {
    let ownsOldNFT = await doesOwnOldNFT(
      ["0x746Cb4219170308Bc6698020811138dDc3A31A57"],
      [-1],
      [false],
      viewerAddress
    );
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove X&ND gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "c4d31de3-af7b-4d0d-bf7b-0506a92fc541") {
    let ownsOldNFT = await doesOwnOldNFT(
      ["0x746Cb4219170308Bc6698020811138dDc3A31A57"],
      [-1],
      [false],
      viewerAddress
    );
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove Mike second stream gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "7054c8dc-d28a-4ec8-953f-4f166488c81e") {
    let ownsOldNFT = await doesOwnOldNFT(
      ["0x7a3082FAEc6b184479913E69f4F3d5f3856dBb17"],
      [5],
      [false],
      viewerAddress
    );
    ownsOldNFT = ownsOldNFT ||
    viewerAddress.toLowerCase() === "0x10d0b1df6894b6acf9b00d921b0705ef10504564";
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove Yahzarah gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "c34434bd-12d2-4915-8084-354fbf510598") {
    let ownsOldNFT = await doesOwnOldNFT(
      [
        "0xcF3806FB823dd39d525Ed935ba083610Ed6324f6",
        "0xabEFBc9fD2F806065b4f3C237d4b59D9A97Bcac7",
        "0xabEFBc9fD2F806065b4f3C237d4b59D9A97Bcac7",
        "0x66cae026fccdccebb6887f4adef54dc3a996be7a"
      ],
      [-1, 2616, 7191, -1],
      [false, true, true, false],
      viewerAddress
    );
    console.log(ownsOldNFT);
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove Joe Rian gating by old
  if(item != null && viewerAddress !== "" && item["authUUID"] === "f828c5f9-1a8f-44cb-b5d5-9724b1a11e36") {
    let joeAllowedViewers = [
      "0xb94225358c5f719c6dcf32964edca3860a4f21e7",
      "0x40df4dc41fc5dd7828b122cd2ad8f34ebde86fd5",
      "0x22f3932d790b7f40599ec24b849a30aba9a15ab6",
      "0x1cf0ae5e15a2b97a62f51b8ff0bcd27db994e6d6",
      "0xe9bc78a30775c182d85093d6992e76382121beac",
      "0x75cd68e2c3365353f1f7f39bc3d8773204bf0e17",
      "0x1663f963c80aafd10df7cc7ebd03596e234faf46",
      "0x2b5bb697dccdadbe46d3c5e88cb7102f642bd74d",
      "0xdd18788941df326fb8e68cd7c205616692dcce26",
      "0x6c0b623c9de411245e9b675a1e0e711340823e3f",
      "0x01b5e05083e85459ffa0b57baa312f51eaf0fe61",
      "0xa6e4393d9fe60dda6ad1c7d57a5b8cbc149480f5",
      "0x1876aac2a7ec76aec5f01cc97ac56569d582e0c0",
      "0x867eb0804eaca9feeda8a0e1d2b9a32eef58af8f",
      "0xfcb96be03759bb0bf995145096144da73b33f05c",
      "0xd96e4656f8906b215b2ca71a785ace94e1fa278b",
      "0x751f7a34666f54ea2bfeebf23a261ff4f0542796",
      "0x6099381e17d4ffb7a2717bb7ee8067867442aa55",
      "0x65240ed16d442e2fd6c64b63a5f6d22dd3c42955",
      "0xf7d005d4d7bddb6285714e403da7677f03bf21b4",
      "0x3e5928c6d059a38bf0329694908604a0eedb0919",
      "0xc9613b6c2fc7833ac40865fb5a02f2c693143741",
      "0xb12c41180f1e26f9d6e4dddc5c5d8f12136b2047",
      "0x81c874020282397cc05009fba791deba802ee531",
      "0x5ed2698484c888c5701bc0af690cca67f67bc000",
      "0x67b63789e5b852480f942aeab68c66464fa1c883",
      "0xd9d451582c9ab1374e48df38a31f4fa640dd72b0",
      "0x54c3ffe48a5dace71098b49c912b16521bcab592",
      "0x0fa6a579b0d79b18ec0d4ec5a2cfd42deddb9915",
      "0xc72da03f7ba9e4a632b5d97562ebac27d294f830",
      "0x5862a7f63ffa1f33bb80d62034b3776d4903cba5",
      "0xb0f36d7c5eb6eae5682ef7ab2a9f42c92e11726a",
      "0xe03927c7912d71d9d6e24c0c5fa93886fc860651",
      "0xb09f09b1c3dfadfbfe1dac72cbcab6451d00f433",
      "0xd803ba08bc87a7b765956d13d50bc5d1f37db936",
      "0xd1abb45858c7de47c7e5a798946c7fbe746e439e",
      "0x110aa4dd95018cf48c3fa38f45ab3d5d365c11f5",
      "0xfebbb48c8f7a67dc3dcee19524a410e078e6a6a1",
      "0x8f6f410f8e92304690493df40c521a3dab160109",
      "0x5de59d7ae4998285a335e2eeb7abcc48a8fccf7e",
      "0xd5d30906f6cf5bc0682ef355d970b10b43c752ab",
      "0x615cbcb2739c340d3e61adc6003445c322627070",
      "0x9d747a2b14b445c6e49a17f7595fa17371330b41",
      "0x93e4457d30a590bf0a0092a1c33e352851f76b51",
      "0x05df284b55dec293a52a951f2a59df932d599ea2",
      "0x8a486e5eab5cccab6aae6697a56d23b34f857350",
      "0x85e9f6f41eb17ddd126a0072e6a9c6f9a52390e6",
      "0x46ef891293091a377a5e0821da7dc4f278d9ed98",
      "0x614080b24f8afe7ee7a7e5865b0ab7622ee55013",
      "0xe438751b44a9c6288fd97634d5f5ef2741b686c4",
      "0xbffea57972fc6bd0498992ce29ffb8c14b904327",
      "0x3f6dd9d4aa71d5fd0db2be68b653a92fedc24a80",
      "0xcc7eebb8af8152c30ab68afa736868f27170c358",
      "0x90992dcb0fdaeb990c73ca1682a7e2a30337d0c8",
      "0x2826d9538e8be3b713f28c846b2b0ee371997154",
      "0x687ca7c90bbb9aa06d43b2941f4163fb7902671f",
      "0x1892eb7bc7f2032fc81799aaed8279a03c2cf380",
      "0xcc8da0c0ed9ddf043586b3860020d6f7c9fa7362",
      "0x66836a537c6a04d2fcafade98f962fd9ae0f6dc0",
      "0x25040107eedc2ec8b3bdccacb6eab38fba706f2c",
      "0x6100049d85a9b2cdb3c12048cd1d06221c9f96fd",
      "0x73241ebe4db860bbc7e1dd2b0f0805e2e14c2b4f",
      "0xfa9ec39c07071c79ab3eba979ce21931f79a4f10",
      "0xad5e2343950c305b2e942266d2cb8eb633d9f7ac",
      "0xe4fadeca360813e6d0aff959e0f7f256eea5a26b",
      "0x858538bd9d3f3433e2701e0ddc1e3d4a165699a0",
      "0xc214c815524189ff0947c860b1c23836f3eae3a1",
      "0x043db7f3b2bf07ed0404cc241af842846c023721",
      "0xfdbb6ba767d1728d1283f7c61f62310ed473eb2a",
      "0x94daf820277d09d2124a922609161974361af459",
      "0x94f6ff0240208027cfdd28601bfa7a852aff1f30",
      "0x6910e8060fd70bc52d1daed2b62d217cedf487d6",
      "0xafbf70177d56a1088f8f4b1ec1195e9ade89f61e",
      "0x6798b6ddba0588c044038370c57ac208c2769c7f",
      "0x6fe073b6a3c8aa4735300f4aade4fbe8c56408f3",
      "0xa151f0bb79405065a10b8d4021bbbfc70fdba208",
      "0x7a53a221cab1302857f32fd8f154e7e4038dd41d",
      "0xd6439e082cfd5647b270ddc108f32b081c677d12",
      "0xe5277582d1ce7c545c4609019f14f5228142c510",
      "0x62cba5545dcd9b24ae094454394083840a0ef82d",
      "0xd1decdf17c99a7349b12d341a6e6509a30251f37",
      "0x92cc17c86ebf30cb1d80c6c7ba497f002e623647",
      "0x847a457740507f4fdfbd9eb979deec01ea6e6d2f",
      "0x5c50f99393e2c9d7922a8dcb1800808d46f2bdd9",
      "0x5446c2b9bd4fec5ccac430c8469ee5803552b6f9",
      "0x197cd8e056b6cc93700f56ff38d5c13b613f57e8",
      "0x81a4f4d9f4d23c580372046cd42f9903f0b15997",
      "0x876bfce43db4e6ebbbd12ff73b1a33cbce8c2dc0",
      "0xd83129f8ce0060f0256bfa9cb6d15e547e4ef5f1",
      "0xeafdd35e23abf7d932f3afe5755aab40c53fad6b",
      "0x0b4f4f2ae80eb9363bd2b28165c5a4ea5af3261e",
      "0x7e5ed83fe9fe3cb47fa04d36e49bebda164c3aae",
      "0x28f40f5562acda2ab4f65b727785d0960350c757",
      "0xc519652a8c31d9c6d01e5720f2bb487c7627cff1",
      "0x9e0149f7cc28c93a3b5f76ab3e8a2a22d14435b5",
      "0xb1ef4840213e387e5cebcf5472d88fe9c2775dfa",
      "0x4dede6d1d40bd3de55831c325b5f5b65f2e06d05",
      "0xda1a6af84084eabf1275bab59e9c0512df882388",
      "0xd8f5ba4b9b6f29b9b4aca3cdc3b46bf5bcc9b7ed",
      "0x044dac6f5aba1e5973242e40931990792b918018",
      "0x0c4956caa320ced206049ff8db698644a2d22769",
      "0xf89f03e3126e744958668794a37285b315f9df65",
      "0x76002c294bdf85e74e59d8a62bb1418c56da4ae7",
      "0x495f947276749ce646f68ac8c248420045cb7b5e",
      "0x91d262ba741e46058f68a45b664d8ff2d4c51596",
      "0x8da220b4e8f6a9280a0963af019658d9b3b2f050",
      "0xfc2d538d97caaf6e6832cf754c9ec019fc3e776c",
      "0xb16ebe3142c3c5e7e104b6ae4a2e47694f1fd6b8",
      "0xc4e34bcd96d88f5b759c7c9e33fe0956885ac7dd",
      "0x4ac965a17a6bb43d30a88b3f3bc35fc73fc727a7",
      "0xed35e8c2ef7dce8ab4a231357a15b82eeabdf261",
      "0xd04a0581a7c9f6332ddc247af0995682bd98e4e9",
      "0x3d7e5ab9622eda953cecdef190daf0b07585ba66",
      "0x9d3a509812cc63726e4e148dcf766b7c577c1e46",
      "0x71cdfd976a86d6daf64959887083bc12e2d45e33",
      "0x128472a1edc94c04888c8b3094994af0f88abf7d",
      "0x5e01a1d09cefc58612b75e5dd5fd9169c155b3f1",
      "0x5746abcd8955535de063de44c1be6a090fe1dedf",
      "0x783779b8d95febcf6cc5b6b0a3204dab8c1005cc",
      "0x5b99e401d15a3d8083ff1708dba847cfe4be3bad",
      "0x88a8977cee0ea89304f9afefdd3b11faffda743c",
      "0x9d44c131e702ac25cead57943ceac7ecb35b7817",
      "0x387fc36b9f989c6a4bb32eae7988f63ff7f369a0",
      "0xf0ff54cbf7a8ff9ff3f97cf4eb66f8aab9cd503e",
      "0x2ad053f19368232a7cec5f244cdd9c42f160a8c5",
      "0x13a41b95d6ff7cd0b951f08ec5883a2567935f2e",
      "0x2d3773eb1a48299ebe90433b5d4f6eca48b66560",
      "0x2a4765e17ea73ccc3756eb4802787fbda27c1c23",
      "0xc28fc1bc6afddcdd2289f0c23692a4f2cc7e0b8a",
      "0x52e79b810e3801f586e07bbeda57d942d01056bc",
      "0x63ea925e98e20a3a3b79b8ce22272bbcaa738a17",
      "0x8d39c1f5081bbc71241a15d58699767fa13d4ec6",
      "0xe9225f057a16f600c4ee2b6c169e93534381d0d0",
      "0xc0af52612c31746019dc9e777abc4c2969f48866",
      "0x2892e4e34a1946975bcf8a4299d622930e376ef8",
      "0xafb38556ec5649eb6f12ed90092cb26a6f26b5b8",
      "0x40030d0b7f15b43df0594e570bfa36e5c0fd3b1d",
      "0xb4fa18fbbab81ad88d551cb991573e9f36ac9f54",
      "0x7899dcb82cac08b1430a13cc6620cc5e27e01dfc",
      "0xc3494e000a9fbe4af024a6945bb1dc63e4fe3ab1",
      "0xe6bd7d30192f63818c77add7073706c6d5491c50",
      "0x0cb599da51d1d26ff225935312ef714f4df2e021",
      "0xbff23601de2c1263c70d492e9f5b420b3d844c4e",
      "0xcedffc717653846c4df61445d0db7c8c52720cfc",
      "0xe00f5f98ce064484c30e45002618c46f31272bdc",
      "0x34b6456a4f8097807d2b38144537ca0a34a700b2",
      "0x4aa009875ec10688c8a7664937c97a82dcf78d23",
      "0xbed0f8b7916c3b0a49457aeb3e83866f8ff0396c",
      "0xf45faa94b9d6895ca603fe510792cf48d5b0a4cb",
      "0xf28608042bf2193e3b158b60ed5f33d4aa0736ce",
      "0xf208127d6325daaa568f031709a31d198b08d0f5",
      "0xf885908d5034cf92ba299faadb7e8e20948363df",
      "0xbb13c0560c8a8354e6a914f1f2b873cefe0df9f7",
      "0xb28331d403719c3caa568645182590a767481ce0",
      "0xe9f131dc66e45cc8a4cd2edda7ab353d88902153",
      "0x8bb7b4d463e81fa26b5d98eca83effd586e43068",
      "0x847134e4e3a0264a86df3f90ac5a8d14c031f8ae",
      "0x74c02691cde824c7696c3b96b5973ad0dcdf0db3",
      "0xc3241afa761db496e1a6935dd616417ff607ecd0",
      "0x39a54e279c69758b507a8640822da8604fd1d320",
      "0xad595afc4767c8cbf6e2361044bef474f973d420",
      "0x224cb25647d5387f6fc23796e3e0ab461489d472",
      "0xdd29a2f8c5e2ef9d00de8fa2cf292f70befe9b5e"
    ];
    let ownsOldNFT = await doesOwnOldNFT(
      [
        "0xC78cd8AB5a99E295D31dA3230319EBc2f285514D",
        "0xa626F0c2d01281D9f82bfb47Eb39f5Ef66a92d17",
        "0x849300d52007ED74227fEF5bD078DfF273Ef97d3",
        "0xcCD3CBcc6d1135A69D0327440596D6D20cb49984",
        "0x46b95A569Ef932Adc1eBe0000727035eE1F2Da75",
        "0x385973b3BcB4122a67f4B2A240BfDBEE50de5558",
        "0x08CB94F1842c419E3387fFE2B7d2cC5A6748b869",
        "0xd2063d18d0d91bf625fc450662b77c99d425b147",
        "0xb345233fA189C643772a35586b915E222C278d85",
        "0x4B103d07C18798365946E76845EDC6b565779402",
        "0x61028F622CB6618cAC3DeB9ef0f0D5B9c6369C72",
        "0x43ebbeda1AB50de58E2adBC071Ab78D27864B5e4",
        "0xE7e58452708b5Abd240c6b920F8863948478C1E6",
        "0xC5a6afbE82EB9A119ac0d15392CA43B683AE8136",
        "0x6AC19E27CB45E8970b6d3EF0ba8d5480E27c1e1c"
      ],
      [-1, -1, -1, -1, -1, -1, -1, 0, -1, -1, -1, -1, -1, -1, -1],
      [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      viewerAddress
    );
    ownsOldNFT = ownsOldNFT || joeAllowedViewers.includes(viewerAddress.toLowerCase());
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  // TODO remove Dom allowlist everyone
  if(item != null && item["authUUID"] === "58231507-1594-4929-9c7b-b2a42340131e") {
    shouldShowLiveStream = true;
  }
  // TODO remove UVR gating by old
  if(viewerAddress !== "" && creatorAddress.toLowerCase() === "0x7933231775dec3f3c80039debd7e3afd8a81f674") {
    let ownsOldNFT = await doesOwnOldNFT(
      [
        "0xA33EdB3810ee9faE9077dAf9AcDD834E1860a72C",
        "0xBA9034B2Eb278b87676c339E068760c7b29226a1",
        "0x2FFa407f116DF00349eD07f93992a04193Ee15a1",
        "0x6D27462859df2AA5eCCCBd14d68B9742FF48da91",
        "0x57e86cc9588f801fb3ed80c0e1d44f908d5fef1a",
        "0x701e4d82ac93ba786a587790cd7c8dd0b3e99356",
        "0xb28a51651caf66f2f0fbfdbe37424c0ded664b24",
        "0x74e65ee234d93116ae224d77fb7fb813ba360e8a"
      ],
      [-1, -1, -1, -1, -1, -1, -1, -1],
      [false, false, false, false, false, false, false, false],
      viewerAddress
    );
    if(ownsOldNFT) {
      shouldShowLiveStream = true;
    }
  }
  return shouldShowLiveStream;
}